import React from "react";
import {getObjectFromArrayOfObjects} from "./helperFunctions";
import {DoyOptions} from "../_data/clients/doy-options"
import {countryList, countryListEU, countryListNonEU, onlyGreeceList} from "../_data/country-list"
import {vatCategoryData} from "../_data/mydata/vatCategory";
import {vatZeroPerData} from "../_data/mydata/vatZeroPer";
import {getSalesTaxesTemplateData} from "./product-sales-calculations";
import getMyData, {reverseDeliveryNotePurposes} from "./sharedmydata";
import {getBuysTaxesTemplateData} from "./product-buys-calculations";
import QR from 'qrcode-base64'
import moment from "moment/moment";
import {myDataCharOptions} from "../_data/mydata/myDataChar";
import {measurementUnitsData} from "../_data/mydata/measurementUnits";
import {salesPurposeData} from "../_data/mydata/salesPurpose";
import {clientServiceTypes} from "../_data/mydata/clientServiceTypes";
import {toast} from "react-toastify";
import axios from "axios";
import { sha1 } from 'js-sha1';
import {encodeISO88597} from "./encoder";
import {receivingNotePurposeOptions} from "../_data/mydata/receivingNotePurposes";

export const cardTypeOptions = [
	{value: 0, label: "Προπληρωμένη (Prepaid)"},
	{value: 1, label: "Πιστωτική (Credit)"},
]

export const depreciationCalculationOptions = [
	{label: "Ημερήσιος", value: "daily"},
	{label: "Μηνιαίος", value: "monthly"},
]

export const startingPeriodOptions = [
    {label: "Τον μήνα δημιουργίας", value: "currentMonth"},
    {label: "Τον επόμενο μήνα", value: "nextMonth"},
]

export const chequeTypes = [
	{label: "Εισπρακτική", value: 0},
	{label: "Πληρωτέα", value: 1},
]

export const specialProductTypeOptions = () => { // Product recTypes
	return [
		{
			label: "Κενό",
			value: "",
		},
		{
			label: "Δωροεπιταγή",
			value: "6",
		}
	]
}

export const vatIncludedOptions = () => {
	const user = getCurrentUser();
	if (user?.lang && user.lang === "el") {
		return [
			{
				label: 'Περιλαμβάνεται Φ.Π.Α.',
				value: true,
			},
			{
				label: 'Δεν περιλαμβάνεται Φ.Π.Α.',
				value: false,
			}
		]
	} else {
		return [
			{
				label: 'VAT included',
				value: true,
			},
			{
				label: 'VAT Not included',
				value: false,
			}
		]
	}
}

export const getVatCategoryOptions = () => {
	const user = getCurrentUser();
	if (user?.lang && user.lang === 'el') {
		return [
			{
				label: 'Κανονικό Φ.Π.Α.',
				value: 'Normal VAT',
			},
			{
				label: 'Μειωμένο Φ.Π.Α.',
				value: 'Reduced VAT',
			},
			{
				label: 'Μηδενικό Φ.Π.Α.',
				value: 'Zero VAT',
			}
		]
	} else {
		return [
			{
				label: 'Normal VAT',
				value: 'Normal VAT',
			},
			{
				label: 'Reduced VAT',
				value: 'Reduced VAT',
			},
			{
				label: 'Zero VAT',
				value: 'Zero VAT',
			}
		]
	}
}

export const getSexOptions = () => {
	const user = getCurrentUser();
	if (user?.lang && user.lang === 'el') {
		return [
			{
				label: 'Άνδρας',
				value: 'male',
			},
			{
				label: 'Γυναίκα',
				value: 'female',
			}
		]
	} else {
		return [
			{
				label: 'Male',
				value: 'male',
			},
			{
				label: 'Female',
				value: 'female',
			}
		]
	}
}

export const getIsNetValueOptions = () => {
		return [
			{
				label: 'Όχι',
				value: 'false',
			},
			{
				label: 'Καθαρή Αξία για 24%',
				value: '24',
			},
			{
				label: 'Καθαρή Αξία για 13%',
				value: '13',
			},
			{
				label: 'Καθαρή Αξία για 6%',
				value: '6',
			},
			{
				label: 'Καθαρή Αξία για 17%',
				value: '17',
			},
			{
				label: 'Καθαρή Αξία για 9%',
				value: '9',
			},
			{
				label: 'Καθαρή Αξία για 4%',
				value: '4',
			},
			{
				label: 'Καθαρή Αξία για 3%',
				value: '3',
			},
			{
				label: 'Καθαρή Αξία για 0%',
				value: '0',
			},
			{
				label: 'Καθαρή Αξία άνευ Φ.Π.Α. (Μισθοδοσία, Αποσβέσεις κτλπ.)',
				value: '-',
			},
		];
}

export const getTaxTypeOptions = () => {
	return [
		{
			label: "Κενό",
			value: ""
		},
		{
			label: "Παρακρατούμενος Φόρος",
			value: "withHoldTax"
		},
		{
			label: "Λοιπός Φόρος",
			value: "otherTax"
		},
		{
			label: "Τέλος",
			value: "fee"
		},
		{
			label: "Χαρτόσημο (Ψηφ. τέλος συν.)",
			value: "stamp"
		},
	]
}

export const getSubaccountOptions = () => {
	const user= getCurrentUser();
	if(user?.lang && user.lang === 'el') {
		return [
			{
				label: 'Δεν υποστηρίζει',
				value: '',
			},
			{
				label: 'Εγκαταστάσεις',
				value: 'installation',
			},
			{
				label: 'Πελάτες',
				value: 'client',
			},
			{
				label: 'Προμηθευτές',
				value: 'supplier',
			},
			{
				label: 'Εργαζόμενοι',
				value: 'employee',
			},
			{
				label: 'Τραπεζικός Λογαριασμός',
				value: 'bankAccount',
			},
			{
				label: 'POS',
				value: 'pos',
			},
			{
				label: 'Ταμειακή Μηχανή',
				value: 'cashRegister',
			},
			{
				label: "Μέτοχος",
				value: "stockholder"
			},
			{
				label: "Κάρτα",
				value: "card"
			}
		]
	} else{
		return [
			{
				label: 'No SubAccount',
				value: '',
			},
			{
				label: 'Installations',
				value: 'installation',
			},
			{
				label: 'Clients',
				value: 'client',
			},
			{
				label: 'Suppliers',
				value: 'supplier',
			},
			{
				label: 'Bank',
				value: 'back',
			},
			{
				label: 'Bank Account',
				value: 'bankAccount',
			},
			{
				label: 'POS',
				value: 'pos',
			},
			{
				label: 'Cash Register',
				value: 'cashRegister',
			},
			{
				label: "Stockholder",
				value: "stockholder"
			},
			{
				label: "Card",
				value: "card"
			}
		]
	}
}

export const getEmployeeTypeOptions = () => {
	// Backend existence too
	return [
		{
			label: 'Κανονικός',
			value: 'normal',
		},
		{
			label: 'Εργατοτεχνίτης Οικοδομικών Εργασιών',
			value: 'constructionWorker',
		},
		{
			label: 'Ναυτικός',
			value: 'marine',
		},
		{
			label: 'Επαγγελματίας Με ΙΚΑ',
			value: 'professionalWithIka',
		},
		{
			label: 'Ειδική Κατηγορία',
			value: 'special',
		},
		{
			label: 'Εκπαιδευτικός',
			value: 'educator',
		},
		{
			label: 'Απασχολούμενος με Εργόσημο',
			value: 'employeedByErgosimo',
		},
		{
			label: 'Αμοιβόμενος με ΔΠΥ',
			value: 'paidByDPY',
		},
		{
			label: 'Ναυτικός σε Γραφείο',
			value: 'marineOffice',
		},
		{
			label: 'Ωρομίσθιος',
			value: 'hourly',
		}
	]
}

export const getWorkingDaysPerWeekOptions = () => {
	// Backend existence too
	return [
		{
			label: "5-ήμερη",
			value: "5",
		},
		{
			label: "6-ήμερη",
			value: "6",
		},
	]
}

export const getEmployeeCategoryOptions = () => {
	// Backend existence too
	return [
		{
			label: 'Έμμισθος',
			value: 'salaried',
		},
		{
			label: 'Ημερομίσθιος',
			value: 'daily',
		},
		{
			label: 'Ωρομίσθιος',
			value: 'hourly',
		},
		{
			label: 'Εκπαιδευτικός',
			value: 'professor',
		},
	]
}

export const getResignationCauseOptions = () => {
	// Backend existence too
	return [
		{
			label: "Κενό",
			value: ""
		},
		{
			label: "Οικειοθελής",
			value: "voluntary"
		},
		{
			label: "Απόλυση",
			value: "dismissal"
		},
		{
			label: "Συνταξιοδότηση",
			value: "retirement"
		},
		{
			label: "Λήξη Σύμβασης",
			value: "expiredContract"
		},
		{
			label: "Αλλαγή Εργασιακής Σχέσης",
			value: "changeEmploymentRelationship"
		},
		{
			label: "Άλλος",
			value: "other"
		},
		{
			label: "Οικειοθελής με 15 έτη προϋπηρεσίας",
			value: "voluntary15yearExperience"
		}
	]
}

export const getEmployeeBreakOptions = () => {
	// Backend existence too
	return [
		{
			label: "Εντός ωραρίου",
			value: "in",
		},
		{
			label: "Εκτός ωραρίου",
			value: "out",
		}
	]
}

export const getKathestosOptions = () => {
	// Backend existence too
	return [
		{
			label: "Πλήρης",
			value: "full-time"
		},
		{
			label: "Μερική",
			value: "part-time"
		}
	]
}

export const getMyDataEnvironments = () => {
	const user= getCurrentUser();
	if(user?.lang && user.lang === 'el') {
		return [{
			label: 'Δοκιμή',
			value: 'test',
		},
			{
				label: 'Παραγωγή',
				value: 'production',
			}];
	} else {
		return [{
			label: 'Test',
			value: 'test',
		},
		{
			label: 'Production',
			value: 'production',
		}];
	}
}

export const getMyDataModes = () => {
	const user= getCurrentUser();
	if(user?.lang && user.lang === 'el') {
		return [{
			label: 'Ζωντανά',
			value: 'live',
		},
			{
				label: 'Χειροκίνητα',
				value: 'manual',
			}];
	} else {
		return [{
			label: 'Live',
			value: 'live',
		},
		{
			label: 'Manual',
			value: 'manual',
		}];
	}

}

export const getVatCategoryAbroadOptions = () => {
	const user=getCurrentUser();
	if(user?.lang && user.lang ==="el") {
		return [{
			label: 'Κανονικό Φ.Π.Α.',
			value: 'Normal VAT',
		},
			{
				label: 'Μειωμένο Φ.Π.Α.',
				value: 'Reduced VAT',
			},
			{
				label: 'Μηδενικό Φ.Π.Α.',
				value: 'Zero VAT',
			},
			{
				label: 'Προσαρμοσμένο Φ.Π.Α.',
				value: 'Custom VAT',
			}];
	} else {
		return [{
			label: 'Normal VAT',
			value: 'Normal VAT',
		},
			{
				label: 'Reduced VAT',
				value: 'Reduced VAT',
			},
			{
				label: 'Zero VAT',
				value: 'Zero VAT',
			},
			{
				label: 'Custom VAT',
				value: 'Custom VAT',
			}];
	}
}

export const getRecordTypeOptions = () => {
	return [
		{ label: "Κανονική", value: "normal" },
		{ label: "Κλεισίματος", value: "closure" },
		{ label: "Απογραφή", value: "census" },
		{ label: "Απογραφή Έναρξης Αποθεμάτων", value: "census-starting-stock"},
		{ label: "Απογραφή Λήξης Αποθεμάτων", value: "census-ending-stock"},
	]
}

export const getAcquirerPOSOptions = (posObj) => {
    if (posObj?.isWebECR === "true") {
        return [
            { label: "Nexi (PAX, SoftPOS)", value: "nexi" },
            { label: "Nexi (Ingenico)", value: "mellonNexi" },
            { label: "Cardlink", value: "mellonCardlink" },
            { label: "NBG, Payzy", value: "mellonNbg" },
            { label: "JCC, Attica, Pancreta, Tora, PBT, MyPOS", value: "mellonAttica" },
            // { label: "ΔΟΚΙΜΑΣΤΙΚΟ MELLON", value: "testMellon" },
            // { label: "ΔΟΚΙΜΑΣΤΙΚΟ NEXI", value: "testNexi" },
        ]
    } else if (posObj.isETameiaki === "active") {
		return [
			{ label: "ePay", value: "epay" },
			{ label: "VIVA", value: "viva" },
			{ label: "EDPS", value: "edps" },
			{ label: "Worldline", value: "worldLine" },
			{ label: "Cardlink", value: "cardlink" },
			{ label: "Nexi (PAX, SoftPOS)", value: "nexi" },
		]
	} else {
		return [
			{ label: "ePay", value: "epay" },
			{ label: "VIVA", value: "viva" },
			{ label: "EDPS", value: "edps" },
			{ label: "Worldline", value: "worldLine" },
			{ label: "Everypay", value: "everypay" },
			{ label: "SumUp", value: "sumup"},
            { label: "Nexi (PAX, SoftPOS)", value: "nexi" },
            { label: "Nexi (Ingenico)", value: "mellonNexi" },
            { label: "Cardlink", value: "mellonCardlink" },
            { label: "NBG, Payzy", value: "mellonNbg" },
            { label: "JCC, Attica, Pancreta, Tora, PBT, MyPOS", value: "mellonAttica" },
			{ label: "Άλλο", value: "else" },
		]
	}
}

export const bridgedSections = [
	{ label: "Παρακαλώ επιλέξτε κατηγορία...", value: "" },
	{ label: "Εισπράξεις Πελατών", value: "Client Payments" },
	{ label: "Αγορές", value: "Buys" },
	{ label: "Πληρωμές Προμηθευτών", value: "Supplier Payments" },
	{ label: "Πωλήσεις", value: "Sales" },
	{ label: "Κινήσεις Πελατών", value: "Client Movements" },
	{ label: "Κινήσεις Προμηθευτών", value: "Supplier Movements" },
	{ label: "Κινήσεις Ειδών", value: "Product Movements" },
    { label: "Αποσβέσεις", value: "Fixed Asset Records" },
    { label: "Κινήσεις Παγίων", value: "Fixed Asset Movements" },
]

/*
* Get Token From The Local Storage
*/
export const getToken = () => {
  let userToken;
  const token = localStorage.getItem('token');
  if(token) {
    userToken = token.replace(/['"]+/g, '');
  } else {
    console.warn('User token not found.');
    userToken = false;
  }
  return userToken;
}

/*
* Get Decoded Token From The Local Storage
*/
export const getDecodedToken = () => {
  let decodedToken = "";
  let token = getToken();
  if (token && token !== '') {
    decodedToken = jwtDecode(token);
  }
  return decodedToken;
}
// Get Current User Data
export const getCurrentUser = () => {
	const token = localStorage.getItem("token");
	let user = localStorage.getItem("user");
	if (!user) {
		user = getDecodedToken(token);
	} else {
		user = JSON.parse(user);
	}
	if (user && token && token !== '') {
		return user;
	} else {
		return false;
	}
}

// Get dropdown options by category data
export const productCategoryOptions = (data) => {
	let options = [];
	data.forEach((item) => {
		let obj = {};
		obj.label = item.title;
		obj.value = item._id;
		obj.color = '#76AEB7';
		if ((item.isActive !== "false") && (item.type === "product")) {
			options.push(obj);
		}
	 });
	return options;
}

// Covert Code to Code Mask e.g. cmd-000 to cmd-***
export const getMaskCode = (code)  => {
	if (code !== '' && code !== undefined) {
		const maskCodeArr = code.split("-");
		return maskCodeArr[0] + '-****';
	}
	return '';
}

// Get Mask Code Prefix
export const getMaskCodePrefix = (code)  => {
	if (code !== '' && code !== undefined) {
		const maskCodeArr = code.split("-");
		return maskCodeArr['0'];
	}
	return '';
}
// It will replace the prefix of given code
export const getMaskCodeWithNewPrefix = (code, prefix)  => {

	if ((code !== '') && (code !== undefined)) {
		const maskCodeArr = code.split("-");
		const maskCodeArrLen = maskCodeArr.length;
		return prefix + '-' + leadingZeros(maskCodeArr[maskCodeArrLen - 1], 4);
	}
	return code;
}

export const leadingZeros = (num, size) => {

	if (num && num !== '') {
		num = parseInt(num).toString();
		while (num.length < size) {
			num = "0" + num
		}
	}
	return num;
}

// Years for ERP Company Selection
export const companyYearOptions = () => {
	const startYear = 2022;
	const endYear = new Date().getFullYear();

	let options = [];
	for(let year = endYear; year >= startYear; year--) {
		options.push({ label: String(year), value: String(year) });
	}

	return options;
}

// Get Template Options
export const getTemplateOptions = (data)  => {
	if (data && data.length > 0) {
		return data.map((template) => ({
			value: template._id,
			label: template.name,
			color: "#76AEB7",
		}));
	} else {
		return [];
	}
}

// Get Objects from Array of Object for Dropdown and Advanced Combobox
export const getOptionsByData = (data, field1, field2)  => {
	if (data && data.length > 0) {
		return data.map((item) => ({
			value: item[field1],
			label: item[field2],
			// color: "#76AEB7",
		}));
	} else {
		return [];
	}
}

// Get Object by label / value
export const getDefaultOptionObject = (label, value)  => {
	if (label && value) {
		return {
			value: value,
			label: label,
			color: "#76AEB7",
		}
	} else if (label !== ''){
		return {
			value: label,
			label: label,
			color: "#76AEB7",
		}
	} else {
		return null;
	}
}

// Get Default Object By Value
export const getDefaultOptionByValue = (data, id, field = 'id', field1, field2) => {
  let output = {};
  if (data && data.length > 0) {
    const opobj = getObjectFromArrayOfObjects(data, id, field.trim());
    if (opobj.length > 0 && opobj !== 'undefined') {
        output.label = opobj['0'][field1];
    	output.value = opobj['0'][field2];
    }
  }
	return output;
}

// get DOY options
export const getDOYOptions = () => {
 	return getOptionsByData(DoyOptions, 'value', 'label');
}

// get Country options
export const getCountryOptions = (type = 'all') => {
	let options = [];
	if (type === 'all') {
		options = getOptionsByData(countryList,'code', 'name');
	} else if (type === 'greece') {
		options = getOptionsByData(onlyGreeceList,'code', 'name');
	} else if (type === 'insideEU') {
		options = getOptionsByData(countryListEU,'code', 'name');
	} else if (type === 'outsideEU') {
		options = getOptionsByData(countryListNonEU,'code', 'name');
	}
	return options;
}

// Get Key by Name
export const getKeyByName = (name, prefix) => {
	let key = '';
	if (name) {
		if (prefix && prefix !=='') {
			key = prefix + name.toLowerCase().trim().replaceAll(' ', '_').replaceAll('-', '_')
		} else {
			key = name.toLowerCase().trim().replaceAll(' ', '_').replaceAll('-', '_')
		}
	}
	return key;
}

export const getSavedHiddenColumns = (tableName, tableColumns, userSettings) => {
	if (!['Product Balance Report', 'Sales Balance Sheet', 'Client Payments Report', 'Buys Balance Sheet', 'Supplier Payments Report', 'Product Movements Report', 'Client Balance Report', 'Supplier Balance Report'].includes(tableName)) {
		if (!userSettings?.tablesColumns) return tableColumns;
		const tablesColumns = userSettings.tablesColumns[tableName];
		if (tablesColumns) {
			tableColumns.forEach(el => {
				el.hiddenColumn = !tablesColumns.includes(el.field);
			});
			return tableColumns;
		}
	}
	return tableColumns;
}

// get Installations Types
export const getInstallationsTypes = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang ==="el") {
		let options = [{
			label: 'Κεντρικό',
			value: "1",
			color: '#76AEB7'
		},
		];

		for(let oid = 2; oid <= 50 ; oid++) {
			options = [...options, { label: `Υποκατάστημα ${oid - 1}`, value: oid.toString() }]
		}
		return options;
	} else {
		let options = [{
			label: 'Main Offices',
			value: "1",
			color: '#76AEB7'
		},
		];

		for(let oid = 2; oid <= 50 ; oid++) {
			options = [...options, { label: `Office Address Subsidiary ${oid - 1}`, value: oid.toString() }]
		}
		return options;
	}

}

// get Installations Types
export const getMainInstallation = () => {
	let firstInstalltion = null;

	let allInstallations = getInstallationsTypes();
	if (allInstallations.length > 0) {
		firstInstalltion = allInstallations['0'];
	}

	return firstInstalltion;
}

export const getMultiSelectOptionsToArrayEdit = (data, invoiceTypes) => {
	let array = [];
	if (data && data.length > 0) {
		data.forEach((item) => {
			let name = invoiceTypes.find(type => type.value === item);
			let obj = {label:name.label, value: item}
			array.push(obj)
		});
		return array;
	}
}
export const getMultiSelectOptionsToArrayEditEditable = (data, options) => {
	let array = [];
	if (data && data.length > 0) {
		data.forEach((item) => {
			if(item?.value){
				let name = options.find(type => type.value === item.value);
				if(name) {
					let obj = {label: name.label, value: item.value}
					array.push(obj)
				}
			} else {
				let name1 = options.find(type => type.value === item);
				if(name1) {
					let obj1 = {label: name1.label, value: item}
					array.push(obj1)
				}
			}
		});
		return array;
	}
}

// comma separated data to dropdown options
export const getOptionsByCommaString = (str) => {
	let output = [];
	if (str) {
		const strArray = str.split(',');
		output = strArray.map((item) => ({
			value: item,
			label: item,
			color: "#76AEB7",
		}));
  }
	return output;
}

// Print Preference
export const getPrintPreference = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el")
	{
		return [{
			label: 'Εκτυπωτής',
			value: 'printer',
			color: '#76AEB7'
		},
			{
				label: 'PDF',
				value: 'pdf',
				color: '#76AEB7'
			},
			{
				label: 'Excel',
				value: 'excel',
				color: '#76AEB7'
			},
			{
				label: 'Word',
				value: 'word',
				color: '#76AEB7'
			},
		];
	} else {
		return [{
			label: 'Printer',
			value: 'printer',
			color: '#76AEB7'
		},
			{
				label: 'PDF',
				value: 'pdf',
				color: '#76AEB7'
			},
			{
				label: 'Excel',
				value: 'excel',
				color: '#76AEB7'
			},
			{
				label: 'Word',
				value: 'word',
				color: '#76AEB7'
			},
		];
	}
}


export const clearEmptyValuesFromObject = (obj) => {
	for (let propName in obj) {
		if (obj[propName] === null || obj[propName] === 'null' || obj[propName] === '' || obj[propName] === undefined || (Array.isArray(obj[propName]) && obj[propName].length === 0)) {
			delete obj[propName];
		}
	}
	return obj;
}

// Get New Mask Codee
export const getGeneratedMaskCode = (type = 'product', data, product_categories = null,categoryMaskCodePrefix) => {
	let maskCode = 'PC-001';
	if(product_categories !== null && data !== '') {
		for (let i = 0; i < product_categories.length; i++) {
			if (data === product_categories[i]._id) {
					let lastMaskCode = product_categories[i].maskCodeCounter;
				if (type === 'product') {
					maskCode = categoryMaskCodePrefix + '-' + leadingZeros(lastMaskCode, 4);
				}

				if (type === 'client') {
					maskCode = categoryMaskCodePrefix + '-' + leadingZeros(lastMaskCode, 4);
				}
			}
		}
	}

	return maskCode;
}


// Get New Mask Codee
export const getGeneratedMaskCodeCLient = (id, client_categories = null, categoryMaskCodePrefix) => {
	let maskCode = 'PC-001';
	if(client_categories !== null && id !== '') {
		for (let i = 0; i < client_categories.length; i++) {
			if (id === client_categories[i]._id) {
					let lastMaskCode = client_categories[i].maskCodeCounter;
					maskCode = categoryMaskCodePrefix + '-' + leadingZeros(lastMaskCode, 4);
				}
			}
		}
	return maskCode;
}

// Filter Movements PreNumber Not Already in use on document numbering page.
export const filterUsedPreNumbers = (allInstallations, documentNumbering, currentValue = '', installationValue = "") => {
	let filteredInstallations = allInstallations;
	if (allInstallations.length > 0 && documentNumbering.length > 0) {
		return allInstallations.filter((item) => {
			// Show Current Value
			if (currentValue !== '' && item.value === currentValue) {
				return true;
			}
			// Filter the used values
			// let obj = documentNumbering.find((item2) => item2['preNumber'] == item.value);
			let obj = documentNumbering.filter(item2 => {
				if (item2.preNumber === item.value && item2.installation === installationValue) {
					return item2;
				} else {
					return false;
				}
			});
			return !(obj && obj.length > 0);
		});
	}
	return filteredInstallations;
}

// Filter Numbering Modes
export const filterUnusedNumberingModes = (allModes, documentNumbering, showAll = false) => {
	let filteredModes = allModes;
	if (allModes && documentNumbering && allModes?.length > 0 && documentNumbering?.length > 0) {
		return allModes.filter(function(item) {
			// Filter the used values
			let obj = documentNumbering.find((item2) => item2.numberingMode !== item.value);
			if (obj && !showAll) {
				return false;
			} else if (obj && showAll && documentNumbering.length > 1) {
				return false;
			}

			return true;
		});
	}
	return filteredModes;
}

// Get PreNumber by Selected Installation Value
export const getPreNumberByInstallation = (documentNumbering, value, field = 'installation') => {
	let preNumber = "";
	if (documentNumbering && documentNumbering.length > 0) {
		let documberNumberRow = documentNumbering.filter((item) => item[field] === value);
		if (documberNumberRow.length > 0) {
			preNumber = documberNumberRow['0'].preNumber;
		}
	}
	return preNumber;
}

// Get Number by Selected Installation Value
export const getNumberByInstallation = (documentNumbering, value, field = 'installation') => {
	let number = "";
	if (documentNumbering && documentNumbering.length > 0) {
		let documberNumberRow = documentNumbering.filter((item) => item[field] === value);
		if (documberNumberRow.length > 0) {
			number = documberNumberRow['0'].number;
		}
	}
	return number;
}

// Get Mode by Selected Installation Value
export const getModeByInstallation = (documentNumbering, value, field = 'installation') => {
	let mode = "";
	if (documentNumbering && documentNumbering.length > 0) {
		let documberNumberRow = documentNumbering.filter((item) => item[field] === value);
		if (documberNumberRow.length > 0) {
			mode = documberNumberRow['0'].numberingMode;
		}
	}
	return mode;
}

// Get Selected Installation Values from Document Numbering Table
export const getSelectedInstallation = (documentNumbering, value = 'true', field = 'selected') => {
	let selectedInstallation = {};
	if (documentNumbering && documentNumbering.length > 0) {
		let documberNumberRow = documentNumbering.filter((item) => item[field] === value);
		if (documberNumberRow.length > 0) {
			selectedInstallation = documberNumberRow['0'];
		}
	}
	return selectedInstallation;
}

// Get Selected Pre Numbers with Document Types
export const getSelectedPreNumbers = (documentNumbering, allPreNumbers = [], installation) => {
	let preNumbers = allPreNumbers;
	// Get Filtered Objects
	if (installation !== undefined) {
		if (documentNumbering && documentNumbering.length > 0) {
			documentNumbering = documentNumbering.filter(obj => {
				return obj.installationMasterId === installation.toString();
			});
		}
	}
	if (documentNumbering && documentNumbering.length > 0 && allPreNumbers && allPreNumbers.length > 0) {
		preNumbers = documentNumbering.map((item) => ({
			value: item['preNumber'],
			label: item['preNumber'] === 'noprefix' ? 'Κενή' : item['preNumber'],
		}));

		// Remove Duplicates
		preNumbers = removeDuplicateObjects(preNumbers, 'value')
	}

	return preNumbers.filter(Boolean);
}

// Remove Duplicate Objects
export const removeDuplicateObjects = (originalArray, field) => {
	let newArray = [];
	let lookupObject  = {};
	for (let i in originalArray) {
		lookupObject[originalArray[i][field]] = originalArray[i];
	}
	for (let i in lookupObject) {
		newArray.push(lookupObject[i]);
	}
	return newArray;
}

// Get The Last highest value for array of object
export const getLastHighestValue = (data, field = 'id') => {
	let value = 0;
	if (data && data.length > 0) {
		value =	Math.max.apply(Math, data.map(function(o) { return o[field]; }))
	}
	return value;
}

// Set Advanced Type Items ID on delete
export const resetAdvancedTypeItemsID = (data) => {
	// Reset Id, no after delete
	let newData = [];
	if (data && data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			let newObj = Object.assign({}, data[i]);
			newObj.id = i + 1;
			newObj.no = i + 1;
			newData.push(newObj);
		}
		return newData;
	}
	return data;
}

// Set Advanced Type Selected Row
export const setAdvancedTypesSelectedRow = (data, id) => {
	let newData = [];
	if (data && data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			let newObj = Object.assign({}, data[i]);
			newObj.selected = 'false';
			if (newObj.id === id) {
				newObj.selected = 'true';
			}
			newData.push(newObj);
		}
		return newData;
	}
	return data;
}

// Get The Last Highest Value for array of object
export const getLastHighestPrefixNumber = (data, field = 'number', prefix) => {
	let value = 0;
	if (data && data.length > 0) {
		value =	Math.max.apply(Math, data.map(function(o) {
			if (o.preNumber === prefix) {
				return o.number;
			}
			return 0;
		}))
	}
	return value;
}

// Reset Table item id and number on delete
export const resetTableItemsId = (data) => {
	let newData = [];
	if (data && data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			let newObj = Object.assign({}, data[i]);
			newObj.id = i + 1;
			newObj.no = i + 1;
			newData.push(newObj);
		}
		return newData;
	}
	return data;
}

export const getDifficultyOptions = () => {
	return [{
		label: '1',
		value: '1',
		},
		{
			label: '2',
			value: '2',
		},
		{
			label: '3',
			value: '3',
		},
		{
			label: '4',
			value: '4',
		},
		{
			label: '5',
			value: '5',
		},
		{
			label: '6',
			value: '6',
		},
		{
			label: '7',
			value: '7',
		},
		{
			label: '8',
			value: '8',
		},
		{
			label: '9',
			value: '9',
		},
		{
			label: '10',
			value: '10',
		},

	];
}

// Get Dropdown Stockholder Positions
export const getStockholderPositions = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el") {
		return [{
			label: 'Κενό',
			value: '',
		},
			{
				label: 'Μέτοχος',
				value: 'stockholder',
			},
			{
				label: 'Νόμιμος εκπρόσωπος',
				value: 'legal representative',
			},
			{
				label: 'Μέτοχος & Νόμιμος Εκπρόσωπος',
				value: 'stockholder & legal representative',
			},
		];

	} else {
		return [{
			label: 'Blank',
			value: '',
		},
			{
				label: 'Stockholder',
				value: 'stockholder',
			},
			{
				label: 'Legal representative',
				value: 'legal representative',
			},
			{
				label: 'Stockholder & Legal Representative',
				value: 'stockholder & legal representative',
			},
		];

	}
}

// Validate Email Address
export const isValidEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// Is Valid Date
export const isValidDate = (date) => {
  let isValid = false;

	if (date && date !== '') {
		let timestamp = Date.parse(date);
		if (!isNaN(timestamp)) {
			isValid = true;
		}
	}

	return isValid;
};
// Save As Template Clear Fields
export const saveAsTemplateClearTableFields = (data, clear = ['name'])  => {
	let newData = [];
	if (data && data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			let newObj = Object.assign({}, data[i]);
			clear.forEach(item => {
				newObj[item] = "";
			})
			newData.push(newObj);
		}
		return newData;
	}
	return data;
}

// Check if is ISO Date
export const checkIsISODateFormat = (date) =>  {
	if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(date)) {
		return false;
	}
	const d = new Date(date);
	return d.toISOString() === date;
}

// Convert ISO String 2013-03-10T02:00:00Z format to dd/mm/yyyy
export const getISOStringDateToDate = (date) => {
	let newDate = date;

	if (date !== '') {
		let isISODate = checkIsISODateFormat(date);
		if (isISODate) {
			let datetime = new Date(date);
			newDate = datetime.toLocaleDateString('en-GB');
		}
	}

	return newDate;
}

// Get Greek Currency Format
export const getGreekCurrencyFormat = (amount = 0, roundDigits = 2) => {
	const parsedAmount = parseFloat(amount);
	if (!isFinite(parsedAmount)) {
		if (amount?.toString().includes("%") || amount?.toString().includes("€")) {
			// Do nothing
			return amount;
		} else if (isNaN(parsedAmount)) {
			return (0).toLocaleString('el-GR', {style:'currency', currency:'EUR'});
		} else {
			return "-";
		}
	}

	if (roundDigits === 2) {
		amount = parsedAmount.toLocaleString('el-GR', {style:'currency', currency:'EUR'});
	} else {
		amount = parsedAmount.toLocaleString('el-GR', {style:'currency', currency:'EUR', maximumFractionDigits: roundDigits});
	}

	return amount;
}

export const getGreekNumberFormat = (amount = 0, roundDigits = 2) => {
    if (isNaN(amount) || isEmpty(amount)) return "0,00";

    return parseFloat(Number(amount).toFixed(roundDigits)).toLocaleString('el-GR', {minimumFractionDigits: roundDigits, maximumFractionDigits: roundDigits});
}

// Get Multi Select Options to Array
export const getMultiSelectOptionsToArray = (data) => {
	let options = [];
	if (data && data.length > 0) {
		data.forEach((item) => {
			options.push(item.value);
		});
	}
	return options;
}

// It will be used on edit pages to manage the changes log
// Get the differences between two objects
// Obj1 is Old Data
// Obj2 is new data
export const getDifferenceBetweenObjects = (obj1, obj2) => {
	let keysFound = [];

	if (obj1 !== null && obj2 !== null && (typeof obj1 == 'object') && (typeof obj2 == 'object')) {

		let obj1Keys = Object.keys(obj1);
		let obj2Keys = Object.keys(obj2);
		let finalObjectkeys = obj2Keys;

		if (obj1Keys.length < obj2Keys.length) {
			finalObjectkeys = obj2Keys;
		}

		// Delete some keys that no need to compare
		let deleteKeys = ['_id', 'created_at', 'update_at', '__v', 'company', 'year', 'type']
		if (deleteKeys && deleteKeys.length > 0) {
			deleteKeys.forEach(field => {
				// Deleting array values
				let foFIndex = finalObjectkeys.indexOf(field);
				if (foFIndex > -1) {
					finalObjectkeys.splice(foFIndex, 1);
				}
			});
		}

		// Object check top level 1
		finalObjectkeys.forEach(key => {
			if (Array.isArray(obj1[key])) {
				// Inner Array check level 2
				if(JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
					obj1[key].forEach((innerItem, iiIndex) => {
						if(JSON.stringify(innerItem) !== JSON.stringify(obj2[key][iiIndex])) {
							let logChangeMsg = `${key}: => `;
							if (typeof innerItem === 'object') {
									let objVal = getDifferenceBetweenObjects(innerItem, obj2[key][iiIndex]);
									logChangeMsg += `${iiIndex} => ` + objVal;
							} else {
								logChangeMsg += innerItem ? innerItem : 'empty'; // if value of array
							}
							keysFound.push(logChangeMsg);
						}
					});
				}
			} else if (typeof obj1[key] === 'object') {
				// Inner Object Check level 2
				// Object.keys(obj1[key]).forEach((oItem) => {
					if(JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])){
						let logChangeMsg;
						let objVal = getDifferenceBetweenObjects(obj1[key], obj2[key]);
						logChangeMsg = `${key}: => ` + objVal ? objVal : "empty";
						keysFound.push(logChangeMsg);
					}
				// });
			} else {
				// Field value compare level 1
				if(obj1[key] !== obj2[key]){
					let obj1Val = obj1[key] ? obj1[key] : "empty";
					let obj2Val = obj2[key] ? obj2[key] : "empty";
					let logChangeMsg = `${key}: ${obj1Val} → ${obj2Val}`;
					keysFound.push(logChangeMsg);
				}
			}
		});

	} else {
		if ((typeof obj1 == 'object') && (typeof obj2 != 'object')) {
			let logChangeMsg = 'Deleted =>' + (getSearchLogFieldsString(obj1));
			keysFound.push(logChangeMsg);
		} else if ((typeof obj1 != 'object') && (typeof obj2 == 'object')) {
			let logChangeMsg = 'Added =>' + (getSearchLogFieldsString(obj2));
			keysFound.push(logChangeMsg);
		} else {
			console.log('Invalid object found.', obj1, obj2);
		}
	}

	 return keysFound;
};

// Get Totals of fields by data
export const getSearchLogFieldsString = (fields) => {
  let fieldsArr = [];

	if (fields.company) {
    delete fields.company;
  }

  if (fields.year) {
    delete fields.year;
  }

  if (typeof fields === 'object') {
    Object.keys(fields).forEach((field) => {
      let fieldString;

      if (Array.isArray(fields[field])) {
        fieldString = `${field}: ${fields[field].join(', ')}`;
      } else {
        fieldString = `${field}: ${fields[field]}`;
      }

      fieldsArr.push(fieldString);
    });
  }

  return fieldsArr.join(', ');
}

// Sales My Data Status Options
export const salesMyDataStatus = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el"){
		return [
			{
				label: 'Δεν εστάλη',
				value: 'not_sent',
			},
			{
				label: 'Αδυναμία Σύνδεσης',
				value: 'aade_offline',
			},
			{
				label: 'Εστάλη',
				value: 'sent',
			}
		];
	} else {
		return [
			{
				label: 'Not Sent',
				value: 'not_sent',
			},
			{
				label: 'AADE offline',
				value: 'aade_offline',
			},
			{
				label: 'Sent',
				value: 'sent',
			}
		];
	}
}

export const paymentStatusOptions = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el") {
		return [
			{
				label: "Κενό",
				value: "",
			},
			{
				label: "Μη εξοφλημένη",
				value: "unpaid",
			},
			{
				label: "Μερικώς εξοφλημένη",
				value: "semipaid",
			},
			{
				label: "Εξοφλημένη",
				value: "paid",
			}
		]
	} else {
		return [
			{
				label: "Empty",
				value: "",
			},
			{
				label: "Non paid",
				value: "unpaid",
			},
			{
				label: "Semi paid",
				value: "semipaid",
			},
			{
				label: "Paid",
				value: "paid",
			}
		]
	}
}

export const providerChannelOptions = () => {
		return [
			{
				label: 'Κενό',
				value: '',
			},
			{
				label: 'Primer E-shop Plugin',
				value: 'Primer Plugin',
			},
			{
				label: 'eΤαμειακή',
				value: 'eΤαμειακή',
			},
			{
				label: 'Εξωτερικό Λογισμικό',
				value: 'Εξωτερικό Λογισμικό',
			},
			{
				label: ' Primer ERP',
				value: 'ERP',
			}
		];
}


// Buys My Data Status Options
export const buysMyDataStatus = () => {
	return [
		{
			label: 'Not Sent',
			value: 'not_sent',
		},
		{
			label: 'AADE offline',
			value: 'aade_offline',
		},
		{
			label: 'Sent',
			value: 'sent',
		}
	];
}

// Fixed Asset Record MyData Status Options
export const fixedAssetRecordMyDataOptions = () => {
    return [
        {
            label: 'Δεν εστάλη',
            value: 'not_sent',
        },
        {
            label: 'Αδυναμία Σύνδεσης',
            value: 'aade_offline',
        },
        {
            label: 'Εστάλη',
            value: 'sent',
        }
    ];
}

// Sales My Data Status Options
export const salesPrintTemplates = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el") {
		return [{
			label: 'Κενό',
			value: '',
		}, {
			label: 'A4 (Ελληνικό)',
			value: 'sales-print-template1-greek',
		}, {
			label: 'A4 (Αγγλικό)',
			value: 'sales-print-template1-english',
		}, {
			label: 'A5 (Ελληνικό)',
			value: 'sales-print-a5-greek',
		}, {
			label: 'A5 (Αγγλικό)',
			value: 'sales-print-a5-english',
		}, {
			label: 'Διπλό A5 (Ελληνικό)',
			value: 'sales-print-a5-double-greek',
		}, {
			label: 'Διπλό A5 (Αγγλικό)',
			value: 'sales-print-a5-double-english',
		}, {
			label: 'Θερμικός (55mm)',
			value: 'thermal-print-55mm',
		}, {
			label: 'Θερμικός (80mm)',
			value: 'thermal-print-80mm',
		}, {
			label: 'Θερμικός (110mm)',
			value: 'thermal-print-110mm',
		},];
	} else {
		return [{
			label: 'Null (Blank)',
			value: '',
		}, {
			label: 'A4 (Greek)',
			value: 'sales-print-template1-greek',
		}, {
			label: 'A4 (English)',
			value: 'sales-print-template1-english',
		}, {
			label: 'A5 (Greek)',
			value: 'sales-print-a5-greek',
		}, {
			label: 'A5 (English)',
			value: 'sales-print-a5-english',
		}, {
			label: 'Double A5 (Greek)',
			value: 'sales-print-a5-double-greek',
		}, {
			label: 'Double A5 (English)',
			value: 'sales-print-a5-double-english',
		}, {
			label: 'Thermal (55mm)',
			value: 'thermal-print-55mm',
		}, {
			label: 'Θερμικός (80mm)',
			value: 'thermal-print-80mm',
		}, {
			label: 'Θερμικός (110mm)',
			value: 'thermal-print-110mm',
		},];
	}
}

export const quotationsStatusOptions = () => {
	const user = getCurrentUser();
	if (user?.lang && user.lang === "el") {
		return [{
			value: 'used',
			label: 'Χρησιμοποιούμενη'
		}, {
			value: 'unused',
			label: 'Αχρησιμοποίητη',
		},];
	} else {
		return [{
			value: 'used',
			label: 'Used'
		}, {
			value: 'unused',
			label: 'Unused',
		}]
	}
}

export const quotationsPrintTemplates = () => {
	const user = getCurrentUser();
	if (user?.lang && user.lang === "el") {
		return [{
			label: 'Κενό',
			value: '',
		}, {
			label: 'A4 (Ελληνικό)',
			value: 'sales-print-template1-greek',
		}, {
			label: 'A4 (Αγγλικό)',
			value: 'sales-print-template1-english',
		}, {
			label: 'A5 (Ελληνικό)',
			value: 'sales-print-a5-greek',
		}, {
			label: 'A5 (Αγγλικό)',
			value: 'sales-print-a5-english',
		}, {
			label: 'Διπλό A5 (Ελληνικό)',
			value: 'sales-print-a5-double-greek',
		}, {
			label: 'Διπλό A5 (Αγγλικό)',
			value: 'sales-print-a5-double-english',
		},];
	} else {
		return [{
			label: 'Null (Blank)',
			value: '',
		}, {
			label: 'A4 (Greek)',
			value: 'sales-print-template1-greek',
		}, {
			label: 'A4 (English)',
			value: 'sales-print-template1-english',
		}, {
			label: 'A5 (Greek)',
			value: 'sales-print-a5-greek',
		}, {
			label: 'A5 (English)',
			value: 'sales-print-a5-english',
		}, {
			label: 'Double A5 (Greek)',
			value: 'sales-print-a5-double-greek',
		}, {
			label: 'Double A5 (English)',
			value: 'sales-print-a5-double-english',
		},];
	}
}

export const clientPaymentsPrintTemplates = () => {
	const user = getCurrentUser();
	if(user?.lang && user.lang === "el") {
		return [{
			label: 'Κενό',
			value: '',
		}, {
			label: 'A4 (Ελληνικό)',
			value: 'clientpayments-print-template1-greek',
		}, {
			label: 'A4 (Αγγλικό)',
			value: 'clientpayments-print-template1-english',
		}];
	} else {
		return [{
			label: 'Null (Blank)',
			value: '',
		}, {
			label: 'A4 (Greek)',
			value: 'clientpayments-print-template1-greek',
		}, {
			label: 'A4 (English)',
			value: 'clientpayments-print-template1-english',
		}];
	}
}

// Sales My Data Status Options
export const buysPrintTemplates = () => {
	const user = getCurrentUser()
	if(user?.lang && user.lang === "el") {
		return [{
			label: 'Κενό',
			value: '',
		}, {
			label: 'A4 (Ελληνικό)',
			value: 'buy-print-a4-greek',
		}, {
			label: 'A4 (Αγγλικό)',
			value: 'buy-print-a4-english',
		}];
	} else {
		return [{
			label: 'Null (Blank)',
			value: '',
		}, {
			label: 'A4 (Greek)',
			value: 'buy-print-a4-greek',
		}, {
			label: 'A4 (English)',
			value: 'buy-print-a4-english',
		}];
	}
}



// Get Sales Print Data
export const getSalesPrintData = (type, salesData, company, SETTINGS, printLayout)  => {
	/*
		type = templateType
		sales = SALES from state
		company = COMPANY_DATA from state

	    printLayouts for sales:
		sales-print-template1-greek     is A4
		sales-print-template1-english   is A4
		sales-print-a5-greek            is A5
		sales-print-a5-double-greek     is A5
		sales-print-a5-english          is A5
		sales-print-a5-double-english   is A5
	 */
	let size = "A4";
	const isEnglish = String(printLayout).includes("english");
	if (printLayout === "sales-print-a5-greek" || printLayout === "sales-print-a5-double-greek" || printLayout === "sales-print-a5-english" || printLayout === "sales-print-a5-double-english") size = "A5";

	const salesPurposeOptions = getMyData({type: 'salePurpose', settings: SETTINGS});
	let branch = "";
	if (salesData?.installation !== "0"){
		if(company?.companyInstallations?.length > 0) {
			company.companyInstallations.map(installation => {
				if (installation?.installationMasterId === salesData?.installation) {
					branch = installation;
				}
				return installation;
			})
		}
	}

	const advDoc = SETTINGS.settings.advancedTypesSales?.find((el) => el._id === salesData.documentType);

	let templateDate = new Date(salesData.date)
	templateDate = templateDate.getDate()+'/'+(templateDate.getMonth()+1)+'/'+templateDate.getFullYear();
	let printTemplateData = {
		ISSUER_NAME: (isEnglish && company.companyDetails?.englishName) ? company.companyDetails.englishName : company.companyDetails?.name,
		ISSUER_LOGO: company.companyDetails?.useLogo === "active" ? company.companyDetails?.companyLogo : "",
		ISSUER_SMALL_NAME: (isEnglish && company.companyDetails?.englishSmallName) ? company.companyDetails.englishSmallName : company.companyDetails?.smallName,
		ISSUER_SUBJECTFIELD: (isEnglish && company.companyDetails?.englishActivity) ? company.companyDetails.englishActivity : company.companyDetails?.activity,
		ISSUER_ADDRESS: (isEnglish && company.companyDetails?.englishHeadquartersAddress) ? company.companyDetails.englishHeadquartersAddress : company.companyDetails?.headquartersAddress,
		ISSUER_CITY: (isEnglish && company.companyDetails?.englishCity) ? company.companyDetails.englishCity : company.companyDetails?.city,
		ISSUER_TK: company.companyDetails?.postalCode,
		ISSUER_PHONE: (isEnglish && company.companyDetails?.englishPhone) ? company.companyDetails.englishPhone : company.companyDetails?.phone,
		ISSUER_DOY: company.companyDetails?.doy,
		ISSUER_VAT: isEnglish ? `EL${company.companyDetails?.vatNumber}` : company.companyDetails?.vatNumber,
		ISSUER_EMAIL: company.companyDetails?.email,
		ISSUER_GEMH: company.companyDetails?.gemhNo,
		ISSUER_WEBPAGE: company.companyDetails?.webpage,
		ISSUER_AMKA: company.companyDetails?.prescriptionDoctorDetails?.amka,
		BRANCH: branch,
		INVOICE_TYPE: salesData?.documentTypeName,
		SERIES: salesData?.preNumber !== "noprefix" ? salesData?.preNumber : "",
		NUMBER: String(salesData?.number).replace(salesData?.preNumber,''),
		INVOICE_DATE: templateDate,
		INVOICE_TIME: salesData?.time,
		CUSTOMER_CODE: salesData?.clientCode,
		CUSTOMER_NAME: salesData.myDataType === "11.1" || salesData.myDataType === "11.2" || salesData.myDataType === "11.4" ? salesData?.clientName : "",
		CUSTOMER_COMPANY: salesData.myDataType !== "11.1" && salesData.myDataType !== "11.2" && salesData.myDataType !== "11.4" ? salesData?.clientName : "",
		CUSTOMER_ACTIVITY: salesData?.activityName,
		CUSTOMER_EMAIL: salesData?.email,
		CUSTOMER_PHONE: salesData?.phone,
		CUSTOMER_VAT: salesData?.vat,
		CUSTOMER_AMKA: salesData?.amka,
		CUSTOMER_DOY: salesData?.doy,
		CUSTOMER_ADDRESS: salesData?.address,
		CUSTOMER_CITY: salesData?.city,
		CUSTOMER_ZIP: salesData?.pc,
		SALER_NAME: "",
		SALER_COMPANY_NAME: "",
		SALER_EMAIL: "",
		SALER_GEMH: "",
		SALER_VAT: "",
		TAX_REPRESENTATIVE: "",
		TAX_REPRESENTATIVE_VAT: "",
		LOCATION_NAME: "",
		PAYMENT_METHOD: salesData?.paymentTypeName,
		PURPOSE: salesData?.salePurpose !== "19" ? getDefaultOptionByValue(salesPurposeOptions, salesData?.salePurpose, 'value', 'label', 'value')?.label : salesData?.salePurposeName,
		WAY_OF_SENDING: salesData?.extraData[0]?.wayOfSendingGoodsName,
		HIGHLIGHT: "",
		CORRELATION: salesData?.correlationName,
		IS_DELIVERY_NOTE: salesData?.isDeliveryNote,
		DISPATCH_TIME: salesData?.goodsSendDate ? getISOStringDateToDate(salesData?.goodsSendDate) : '',
		VEHICLE_NUMBER: salesData?.extraData[0]?.carNumberName,
        REVERSE_DELIVERY_NOTE_PURPOSE: salesData?.reverseDeliveryNotePurpose
            ? (reverseDeliveryNotePurposes.find((el) => el.value === salesData.reverseDeliveryNotePurpose)?.label || "") : "",
        VAT_PAYMENT_SUSPENSION: salesData?.vatPaymentSuspension === true,
		VATEXPCAT: "",
		VATEXPCATCODE: "",
		INVOICE_NOTES: salesData.notes,
		TOTAL_QTY: salesData.totalQuantity,
		TOTAL_WITHOUT_DISCOUNT: salesData?.enablePeppol === "active" ? Number(salesData.totalBeforeDiscount).toFixed(2) : getGreekCurrencyFormat(salesData.totalBeforeDiscount),
		TOTAL_DISCOUNT: salesData?.enablePeppol === "active" ? Number(salesData.totalDiscount).toFixed(2) : getGreekCurrencyFormat(salesData.totalDiscount),
		TOTAL_NOVAT: salesData?.enablePeppol === "active" ? Number(salesData.totalNetValue).toFixed(2) : getGreekCurrencyFormat(salesData.totalNetValue),
		TOTAL_VAT: salesData?.enablePeppol === "active" ? Number(salesData.totalVatValue).toFixed(2) : getGreekCurrencyFormat(salesData.totalVatValue),
		PRICE_WITHVAT: salesData?.enablePeppol === "active" ? Number(salesData.totalAmount).toFixed(2) : getGreekCurrencyFormat(salesData.totalAmount),
		TOTAL_PRICE: salesData?.enablePeppol === "active" ? Number(salesData.paymentAmount).toFixed(2) + " EUR" : getGreekCurrencyFormat(salesData.paymentAmount),
		TOTAL_TAXES_AMOUNT: 0, // Other & Fees & Stamp
		MARK: salesData?.mark,
		UID: salesData?.uid,
		AUTHCODE: salesData?.authCode,
		TRANSMISSION_FAILURE: salesData?.transmissionFailure,
		MYDATAENVIRONMENT: salesData?.myDataEnvironment,
		MYDATADESTINATION: salesData?.myDataDestination,
		PRODUCT_DETAILS: [],
		VAT_TABLE: [],
		TOTAL_PAGES: [],
		TOO_MANY_CUSTOMER_DETAILS: false,
		SHOW_SIGNATURE_FIELDS: advDoc?.showSignatureFields === "active",
	}
	if (isEnglish && salesData && salesData.salePurpose !== "19") printTemplateData.PURPOSE = salesPurposeData.find((el) => el.code === String(salesData.salePurpose))?.english || "";
	if (!isEmpty(printTemplateData.CUSTOMER_DOY) && !isNaN(printTemplateData.CUSTOMER_DOY)) {
		const matchingDOY = getDOYOptions().find((el) => String(el.value) === String(printTemplateData.CUSTOMER_DOY));
		if (matchingDOY) printTemplateData.CUSTOMER_DOY = matchingDOY.label;
	}
	if (String(printTemplateData.CUSTOMER_NAME).length + String(printTemplateData.CUSTOMER_COMPANY).length
		+ String(printTemplateData.CUSTOMER_ACTIVITY).length + String(printTemplateData.CUSTOMER_ADDRESS).length > 60) {
		printTemplateData.TOO_MANY_CUSTOMER_DETAILS = true;
	}
	if (!isEmpty(salesData?.displayedBalance)) {
		printTemplateData.OLD_BALANCE = getGreekCurrencyFormat(String(salesData.displayedBalance).split(" ")[0]);
		printTemplateData.NEW_BALANCE = getGreekCurrencyFormat(String(salesData.displayedBalance).split(" ")[1]);
	}
	let totalWithhold = 0;
	let totalDeductions = 0;
	const invoiceLevelTax = salesData?.salesTaxes?.find((el) => el.vatPercentage === "Invoice Level Tax");
	if (invoiceLevelTax) {
		totalWithhold += parseFloat(invoiceLevelTax.withholdTaxes);
		if (invoiceLevelTax.deductions && !isNaN(invoiceLevelTax.deductions)) {
			totalDeductions += parseFloat(invoiceLevelTax.deductions);
		}
	}
	const ROW_HEIGHT = 30; // Set the height of each row in pixels
	let MAX_ROWS_PER_PAGE = salesData?.enablePeppol === "active" ? 5 : 11; // Set the maximum number of rows per page
	printTemplateData.PRINT_SIZE = "A4"
	if (size === "A5") {
		MAX_ROWS_PER_PAGE = 6;
		printTemplateData.PRINT_SIZE = "A5"
	}
	let listProducts = [];
	let zeroVatReasons = [];

	if (salesData.products && salesData.products.length > 0) {
		listProducts = [];
		zeroVatReasons = [];
		let currentHeight = 0;
		let pageProducts = [];
		printTemplateData.TOTAL_PAGES.push(1);
		salesData.products.forEach((product) => {
			let cloneProduct = {...product};
			if (salesData?.discountAsLine === true) {
				cloneProduct.discount = 0;
				cloneProduct.netValue = cloneProduct.unitPrice * cloneProduct.quantity;
				cloneProduct.vat = (cloneProduct.unitPrice * cloneProduct.quantity) * (cloneProduct.vatPercentage / 100);
				cloneProduct.totalValue = cloneProduct.netValue + cloneProduct.vat;
			}
			let qtyLabel = measurementUnitsData.find((el) => String(product?.mu) === String(el.code));
			if (qtyLabel && String(product.mu) !== "4") {
				qtyLabel = qtyLabel.shortName;
				if (product.quantity === 1) {
					if (qtyLabel === "Κιλά") {
						qtyLabel = "Κιλό";
					} else if (qtyLabel === "Μέτρα") {
						qtyLabel = "Μέτρο";
					}
				}
			} else {
				qtyLabel = "";
			}
			let productData = {
				CPV_CODE: product?.cpvCode ? product.cpvCode : "",
				PEPPOL_MEASUREMENT_UNIT: product?.peppolMeasurementUnit ? product.peppolMeasurementUnit : "",
				CODE: product.code,
				VAT_ID: product.vatId,
				TAXES_VALUE: parseFloat(
					parseFloat(product.otherTaxEuro) +
					parseFloat(product.feeEuro) +
					parseFloat(product.stampEuro)
				),
				PRODUCT_DESCRIPTION: product.name,
				QTY: String(product.quantity) + String(salesData?.enablePeppol === "active" ? "" : ` ${qtyLabel}`),
				PRICE_QTY: salesData?.enablePeppol === "active" ? Number(product.unitPrice).toFixed(3) : getGreekCurrencyFormat(product.unitPrice, 3),
				VAT: product.vatPercentage,
				DISCOUNT: salesData?.enablePeppol === "active" ? Number(cloneProduct.discount).toFixed(2) : String(cloneProduct?.isPerDiscount) !== "true" ? getGreekCurrencyFormat(cloneProduct.discount) : getGreekCurrencyFormat(cloneProduct.discount).replace("€", "%"),
				PRICE_NOVAT: salesData?.enablePeppol === "active" ? Number(cloneProduct.netValue).toFixed(2) : getGreekCurrencyFormat(cloneProduct.netValue),
				VAT_PRICE: product.taxes
					? getGreekCurrencyFormat(cloneProduct.vat)
					: getGreekCurrencyFormat(0),
				OTHER_TAXES: salesData?.enablePeppol === "active" ? Number(parseFloat(
					parseFloat(product.otherTaxEuro) -
					parseFloat(product.witholdTaxEuro) +
					parseFloat(product.feeEuro) +
					parseFloat(product.stampEuro) -
					parseFloat(product?.deductionsEuro ? product?.deductionsEuro : 0)
				)).toFixed(2) : getGreekCurrencyFormat(
					parseFloat(
						parseFloat(product.otherTaxEuro) -
						parseFloat(product.witholdTaxEuro) +
						parseFloat(product.feeEuro) +
						parseFloat(product.stampEuro) -
						parseFloat(product?.deductionsEuro ? product?.deductionsEuro : 0)
					)
				),
				TOTAL: salesData?.enablePeppol === "active" ? Number(cloneProduct.totalValue).toFixed(2) : getGreekCurrencyFormat(cloneProduct.totalValue),
			}
			if (salesData?.enablePeppol === "active") productData.VAT_PRICE = parseFloat(product.vat).toFixed(2);
			printTemplateData.TOTAL_TAXES_AMOUNT += productData.TAXES_VALUE;
			if (product.vatId === 7) {
				zeroVatReasons.push(product.vatReason);
			}
			const productRowHeight = Math.ceil(
				product.name.length / 50 // Set the maximum number of characters per line
			) * ROW_HEIGHT;
			currentHeight += productRowHeight;
			if (currentHeight > (MAX_ROWS_PER_PAGE * ROW_HEIGHT + 50)) {
				// Start a new page if the current page height exceeds the maximum
				printTemplateData.TOTAL_PAGES.push(1);
				listProducts.push(pageProducts);
				pageProducts = [];
				currentHeight = productRowHeight;
			}
			if (product?.showAlternativeCodeOnPrint === "true") productData.CODE = product.alternativeCode;
			if (product?.showAlternativeNameOnPrint === "true") productData.PRODUCT_DESCRIPTION = product.alternativeName;
			if (!isNaN(parseFloat(product.witholdTaxEuro))) {
				totalWithhold += parseFloat(product.witholdTaxEuro);
			}
			if (product?.deductionsEuro && !isEmpty(product?.deductionsEuro)) {
				totalDeductions += parseFloat(product.deductionsEuro);
			}
			pageProducts.push(productData);
		})
		listProducts.push(pageProducts);
	}
	// Fees, Other Taxes, Withhold Taxes, Stamps that are selected by user to be a line
	if (listProducts?.length > 0) {
		if (salesData.extraData[0]?.withHoldTaxAsLine === "true" && parseFloat(salesData.extraData[0]?.withHoldTaxEuro) > 0) {
			const pStr = "-" + parseFloat(salesData.extraData[0]?.withHoldTaxEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(salesData.extraData[0]?.withHoldTaxAsLineText) ? "Παρακράτηση Φόρου" : salesData.extraData[0]?.withHoldTaxAsLineText,
				QTY: "",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: salesData?.enablePeppol === "active" ? pStr : getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (salesData.extraData[0]?.deductionsAsLine === "true" && parseFloat(salesData.extraData[0]?.deductionsEuro) > 0) {
			const pStr = "-" + parseFloat(salesData.extraData[0]?.deductionsEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(salesData.extraData[0]?.deductionsAsLineText) ? "Γενικές κρατήσεις" : salesData.extraData[0]?.deductionsAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: salesData?.enablePeppol === "active" ? pStr : getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (salesData.extraData[0]?.feeAsLine === "true" && parseFloat(salesData.extraData[0]?.feeEuro) > 0) {
			const pStr = parseFloat(salesData.extraData[0]?.feeEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(salesData.extraData[0]?.feeAsLineText) ? "Τέλη" : salesData.extraData[0]?.feeAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: salesData?.enablePeppol === "active" ? pStr : getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (salesData.extraData[0]?.stampAsLine === "true" && parseFloat(salesData.extraData[0]?.stampEuro) > 0) {
			const pStr = parseFloat(salesData.extraData[0]?.stampEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(salesData.extraData[0]?.stampAsLineText) ? "Χαρτόσημο (Ψηφ. τέλος συν.) (Φόρος)" : salesData.extraData[0]?.stampAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: salesData?.enablePeppol === "active" ? pStr : getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (salesData.extraData[0]?.otherTaxAsLine === "true" && parseFloat(salesData.extraData[0]?.otherTaxEuro) > 0) {
			const pStr = parseFloat(salesData.extraData[0]?.otherTaxEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(salesData.extraData[0]?.otherTaxAsLineText) ? "Λοιπός Φόρος" : salesData.extraData[0]?.otherTaxAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: salesData?.enablePeppol === "active" ? pStr : getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (salesData?.discountAsLine === true) { // Need to edit previous lines, re-calculate totals
			let totalNetDisc = 0;
			let totalVatDisc = 0;
			for (let prod of salesData.products) {
				if (prod.isPerDiscount) {
					totalNetDisc += ((prod.unitPrice * prod.quantity)) * (prod.discount / 100);
					totalVatDisc += ((prod.unitPrice * prod.quantity) * (prod.vatPercentage / 100)) * (prod.discount / 100);
				} else {
					totalNetDisc += prod.discount;
					totalVatDisc += prod.discount * (prod.vatPercentage / 100);
				}
			}
			totalNetDisc = -totalNetDisc;
			totalVatDisc = -totalVatDisc;
			let displayNetDisc = salesData?.enablePeppol === "active" ? Number(totalNetDisc).toFixed(2) : getGreekCurrencyFormat(totalNetDisc);
			let displayVatDisc = salesData?.enablePeppol === "active" ? Number(totalVatDisc).toFixed(2) : getGreekCurrencyFormat(totalVatDisc);

			let discAm = +Number(totalNetDisc + totalVatDisc).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: "-",
				PRODUCT_DESCRIPTION: salesData.discountAsLineText,
				QTY: "",
				PRICE_QTY: displayNetDisc,
				DISCOUNT: "-",
				VAT: "-",
				PRICE_NOVAT: displayNetDisc,
				VAT_PRICE: displayVatDisc,
				OTHER_TAXES: "-",
				TOTAL: salesData?.enablePeppol === "active" ? discAm : getGreekCurrencyFormat(discAm),
				DONT_SHOW_PERCENTAGE: true,
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
	}

	if (totalWithhold) {
		printTemplateData.TOTAL_WITHHOLD = salesData?.enablePeppol === "active" ? Number(totalWithhold) : getGreekCurrencyFormat(totalWithhold);
	}
	if (totalDeductions) {
		printTemplateData.TOTAL_DEDUCTIONS = salesData?.enablePeppol === "active" ? Number(totalDeductions) : getGreekCurrencyFormat(totalDeductions);
	}
	let taxesData = [];
	let vatDataList = vatCategoryData;
	let vatPerReasonList = vatZeroPerData; // Is used to get the reason in exceptional case
	// For PEPPOL BG-21
	if (salesData.extraData[0]) {
		if (salesData.extraData[0].otherTaxEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(salesData.extraData[0].otherTaxEuro);
		if (salesData.extraData[0].feeEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(salesData.extraData[0].feeEuro);
		if (salesData.extraData[0].stampEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(salesData.extraData[0].stampEuro);
	}
	if (printTemplateData.TOTAL_TAXES_AMOUNT > 0) printTemplateData.TOTAL_TAXES_AMOUNT = salesData?.enablePeppol === "active" ? Number(printTemplateData.TOTAL_TAXES_AMOUNT).toFixed(2) : getGreekCurrencyFormat(printTemplateData.TOTAL_TAXES_AMOUNT);
	// Updated calculations for the sales taxes
	let newSalesTaxes = getSalesTaxesTemplateData(salesData.products, SETTINGS);
	if (newSalesTaxes && newSalesTaxes?.length > 0) {
		newSalesTaxes.forEach((tax) => {
			let taxVatPer = tax.vatPercentage;
			let taxVatPerWithoutSymbol = parseFloat(taxVatPer.replaceAll('%', ''));
			let vatObj = getObjectFromArrayOfObjects(vatDataList, taxVatPerWithoutSymbol, 'percentage');
			let taxCode = '';
			if (vatObj.length > 0) {
				taxCode = vatObj['0'].code;
			}
			let taxData = {
				TAX_PERCENT: taxVatPer,
				TAX_CODE: taxCode,
				NET_VALUE: salesData?.enablePeppol === "active" ? Number(tax.netValue).toFixed(2) : getGreekCurrencyFormat(tax.netValue),
				TAX_VALUE: salesData?.enablePeppol === "active" ? Number(tax.vatEuro).toFixed(2) : getGreekCurrencyFormat(tax.vatEuro),
				OTHER_TAXES: salesData?.enablePeppol === "active" ? Number(tax.taxes).toFixed(2) : getGreekCurrencyFormat(tax.taxes),
				TOTAL_VALUE: salesData?.enablePeppol === "active" ? Number(tax.totalValue).toFixed(2) : getGreekCurrencyFormat(tax.totalValue),
			}
			for (let key of Object.keys(taxData)) {
				if (taxData[key] === "NaN") {
					taxData[key] = salesData?.enablePeppol === "active" ? "0.00" : getGreekCurrencyFormat(0)
				}
			}
			taxesData.push(taxData);
		});
	}
	let zeroVatReasonDes = [];
	if (zeroVatReasons.length > 0) {
		zeroVatReasons.map(reason => {
			let vatReasonObj = getObjectFromArrayOfObjects(vatPerReasonList, reason, 'code');
			if(vatReasonObj['0'] !== undefined) {
				let zeroReason = {
					vat: "0%",
					description: (isEnglish ? vatReasonObj['0']?.english : vatReasonObj['0'].description) + ' (' + reason + ')',
					code: reason
				}
				zeroVatReasonDes.push(zeroReason);
			}
			return reason;
		})
	}
	zeroVatReasonDes = removeDuplicateObjects(zeroVatReasonDes, 'code');
	printTemplateData.VATEXPCAT = zeroVatReasonDes;
	printTemplateData.PRODUCT_DETAILS = listProducts;
	printTemplateData.VAT_TABLE = taxesData;
	if (salesData?.extraData && salesData?.extraData.length > 0 && salesData?.myDataType !== "2.1" && salesData?.myDataType !== "2.2" && salesData?.myDataType !== "2.3" && salesData?.myDataType !== "2.4" && salesData?.myDataType !== "11.2" && salesData?.myDataType !== "7.1" && salesData?.myDataType !== "8.1" && salesData?.myDataType !== "8.2") {
		if (salesData?.extraData[0].deliveryLocation === "companyLocation") {
			printTemplateData.LOCATION_NAME = "ΕΔΡΑ ΜΑΣ";
		} else if (salesData?.extraData[0].deliveryLocation === "clientLocation") {
			printTemplateData.LOCATION_NAME = "ΕΔΡΑ ΠΕΛΑΤΗ";
			printTemplateData.LOCATION_ADDRESS = salesData?.address;
			printTemplateData.LOCATION_COUNTRY = salesData?.country;
			printTemplateData.LOCATION_CITY = salesData?.city;
			printTemplateData.LOCATION_ZIP = salesData?.pc;
		} else if (salesData?.extraData[0].deliveryLocation === "custom") {
			printTemplateData.LOCATION_NAME = "ΑΛΛΟ";
			printTemplateData.LOCATION_ADDRESS = salesData?.extraData[0].locationAddress;
			printTemplateData.LOCATION_COUNTRY = salesData?.extraData[0].locationCountry;
			printTemplateData.LOCATION_CITY = salesData?.extraData[0].locationCity;
			printTemplateData.LOCATION_ZIP = salesData?.extraData[0].locationZip;
		}
	}
	let uid = salesData?.uid;
	if((!uid || uid === "") && salesData?.myDataDestination === "provider") {
		if (salesData.myDataRequest) {
			let invoice = JSON.parse(salesData.myDataRequest).invoice[0];
			uid = generateMyDataUID(invoice.issuer.vatNumber, invoice.invoiceHeader.issueDate, invoice.issuer.branch, invoice.invoiceHeader.invoiceType, invoice.invoiceHeader.series, invoice.invoiceHeader.aa);
			printTemplateData.UID = uid;
		}
	}
	// QR Code
	if(salesData?.myDataDestination === "provider") {
		const qrCodeData = 'https://primer.gr/mydatasearch/' + uid;
		// Convert the canvas image to a base64 string
		printTemplateData.QR_CODE = QR.drawImg(qrCodeData, {
			typeNumber: 4,
			errorCorrectLevel: 'M',
			size: 190
		});
	} else if (salesData?.myDataDestination !== "provider" && salesData?.myDataQRURL) {
		const qrCodeData = salesData?.myDataQRURL;
		// Convert the canvas image to a base64 string
		printTemplateData.QR_CODE = QR.drawImg(qrCodeData, {
			typeNumber: 4,
			errorCorrectLevel: 'M',
			size: 190
		});
		printTemplateData.MYDATAQRURL = "YES";
	}
	if (salesData?.transactionDetails) {
		printTemplateData.TRANSACTION_DETAILS = {...salesData.transactionDetails, PAYMENT_METHOD: printTemplateData.PAYMENT_METHOD};
        printTemplateData.PAYMENT_METHOD = "";
	}
	printTemplateData.PAGE_TYPES = [];
	if (salesData?.linkedClientPayments && salesData?.linkedClientPayments?.length > 0 && !printTemplateData.TRANSACTION_DETAILS) {
		if (salesData.linkedClientPayments.length === 1) {
			const payment = salesData.linkedClientPayments[0];
			if (payment.transactionDetails) {
				if (Object.keys(payment.transactionDetails).length > 0) {
                    printTemplateData.TRANSACTION_DETAILS = {...payment.transactionDetails, PAYMENT_METHOD: payment.paymentTypeName};
                    printTemplateData.PAYMENT_METHOD = "";
				}
			}
		} else {
			printTemplateData.PAYMENT_HISTORY = {};
			const filterPOSPayments = [];
			for (let posP of salesData?.linkedClientPayments) {
				if (posP?.transactionDetails) {
					if (Object.keys(posP.transactionDetails).length > 0) {
						filterPOSPayments.push({...posP.transactionDetails, PAYMENT_METHOD: posP.paymentTypeName});
					}
				}
			}
			if (filterPOSPayments?.length > 0) {
				let perPage = 4;
				if (printTemplateData.PRINT_SIZE === "A5") perPage = 2;
				const extraPages = Math.ceil(filterPOSPayments.length / perPage);
				for (let i = 0; i < extraPages; i++) {
					printTemplateData.TOTAL_PAGES.push(1);
					printTemplateData.PAGE_TYPES.push({
						index: printTemplateData.TOTAL_PAGES.length - 1,
						type: "PAYMENT_HISTORY",
					})
					let inPageTransactionDetails = [];
					for (let j = 0; j < perPage; j++) {
						if (filterPOSPayments[perPage*i + j]) {
							inPageTransactionDetails.push(filterPOSPayments[perPage*i + j]);
						}
					}
					printTemplateData.PAYMENT_HISTORY[printTemplateData.TOTAL_PAGES.length - 1] = inPageTransactionDetails;
					printTemplateData.PAYMENT_METHOD = "";
				}
			}
		}
	}
	printTemplateData.ENABLE_PEPPOL = false;
	if (salesData?.enablePeppol === "active") {
		printTemplateData.ENABLE_PEPPOL = true;
		printTemplateData.PEPPOL = {};
		// BT-1
		printTemplateData.PEPPOL.DOCUMENT_REFERENCE
			= `${company.companyDetails?.vatNumber}|${moment(salesData.date).format("DD/MM/YYYY")}|${salesData.installation}|${salesData.myDataType}|${salesData.preNumber === "noprefix" ? "0" : salesData.preNumber}|${salesData.number}`;
		// BT-11 (Α.Δ.Α.)
		if(salesData?.peppol?.projectReference) printTemplateData.PEPPOL.PROJECT_REFERENCE = salesData.peppol.projectReference;
		// BT-46 (Κωδικός Αναθέτουσας Αρχής)
		printTemplateData.PEPPOL.PARTY_IDENTIFICATION = salesData?.peppol?.partyIdentification;
		// BT-12 (ΑΔΑΜ)
		printTemplateData.PEPPOL.CONTRACT_DOCUMENT_REFERENCE = isEmpty(salesData?.peppol?.contractDocumentReference) ? "0" : salesData?.peppol?.contractDocumentReference;
		// BT-3
		printTemplateData.PEPPOL.BT_3_CODE = (salesData.myDataType === "5.1" || salesData.myDataType === "5.2") ? "381" : "380";
		// BT-5
		printTemplateData.PEPPOL.BT_5_CODE = "EUR";
		// BT-31
		printTemplateData.PEPPOL.BT_31_CODE = isEmpty(salesData?.extraData[0]?.locationVatNumber) ? `EL${company.companyDetails?.vatNumber}` : `${salesData?.extraData[0]?.locationVatNumber}`;
		// BT-40
		printTemplateData.PEPPOL.BT_40_CODE = "GR";
		// BT-55
		printTemplateData.PEPPOL.BT_55_CODE = salesData.country;
		// BT-80
		printTemplateData.PEPPOL.BT_80_CODE = isEmpty(salesData?.extraData[0]?.locationCountry) ? salesData.country : salesData?.extraData[0]?.locationCountry;
		// BT-24
		printTemplateData.PEPPOL.BT_24_CODE = "urn:cen.eu:en16931:2017#compliant#urn:fdc:peppol.eu:2017:poacc:billing:3.0";
		// BT-34
		printTemplateData.PEPPOL.BT_34_CODE = `9933:${company.companyDetails?.vatNumber}`
		// BT-49
		printTemplateData.PEPPOL.BT_49_CODE = `9933:997001671`
		// BT-25
		if ((salesData.myDataType === "1.6" || salesData.myDataType === "2.4" || salesData.myDataType === "5.1" || salesData.myDataType === "5.2") && salesData?.peppol?.previousInvoices) {
			printTemplateData.PEPPOL.BT_25_CODE = salesData.peppol.previousInvoices;
		}
		// BG-15 Group (in case of companyLocation)
		if (salesData?.extraData && salesData?.extraData.length > 0) {
			if (salesData?.extraData[0].deliveryLocation === "companyLocation") {
				printTemplateData.LOCATION_NAME = "ΕΔΡΑ ΠΕΛΑΤΗ";
				printTemplateData.LOCATION_ADDRESS = salesData?.address;
				printTemplateData.LOCATION_COUNTRY = salesData?.country;
				printTemplateData.LOCATION_CITY = salesData?.city;
				printTemplateData.LOCATION_ZIP = salesData?.pc;
				/*if (!isEmpty(branch)) {
					printTemplateData.LOCATION_ADDRESS = branch.address;
					printTemplateData.LOCATION_COUNTRY = "GR";
					printTemplateData.LOCATION_CITY = branch.city;
					printTemplateData.LOCATION_ZIP = branch.postalCode;
				} else {
					printTemplateData.LOCATION_ADDRESS = company.companyDetails?.headquartersAddress;
					printTemplateData.LOCATION_COUNTRY = "GR";
					printTemplateData.LOCATION_CITY = company.companyDetails?.city;
					printTemplateData.LOCATION_ZIP = company.companyDetails?.postalCode;
				}*/
			}
		}
	}
	return printTemplateData;
}

export const getQuotationsPrintData = (type, quotationsData, company, SETTINGS, printLayout)  => {
	/*
		type = templateType
		sales = SALES from state
		company = COMPANY_DATA from state

	    printLayouts for sales:
		sales-print-template1-greek     is A4
		sales-print-template1-english   is A4
		sales-print-a5-greek            is A5
		sales-print-a5-double-greek     is A5
		sales-print-a5-english          is A5
		sales-print-a5-double-english   is A5
	 */
	let size = "A4";
	const isEnglish = String(printLayout).includes("english");
	if (printLayout === "sales-print-a5-greek" || printLayout === "sales-print-a5-double-greek" || printLayout === "sales-print-a5-english" || printLayout === "sales-print-a5-double-english") size = "A5";

	let branch = "";
	if (quotationsData?.installation !== "0"){
		if(company?.companyInstallations?.length > 0) {
			company.companyInstallations.map(installation => {
				if (installation?.installationMasterId === quotationsData?.installation) {
					branch = installation;
				}
				return installation;
			})
		}
	}

	let templateDate = new Date(quotationsData.date)
	templateDate = templateDate.getDate()+'/'+(templateDate.getMonth()+1)+'/'+templateDate.getFullYear();
	let printTemplateData = {
		ISSUER_NAME: (isEnglish && company.companyDetails?.englishName) ? company.companyDetails.englishName : company.companyDetails?.name,
		ISSUER_LOGO: company.companyDetails?.useLogo === "active" ? company.companyDetails?.companyLogo : "",
		ISSUER_SMALL_NAME: (isEnglish && company.companyDetails?.englishSmallName) ? company.companyDetails.englishSmallName : company.companyDetails?.smallName,
		ISSUER_SUBJECTFIELD: (isEnglish && company.companyDetails?.englishActivity) ? company.companyDetails.englishActivity : company.companyDetails?.activity,
		ISSUER_ADDRESS: (isEnglish && company.companyDetails?.englishHeadquartersAddress) ? company.companyDetails.englishHeadquartersAddress : company.companyDetails?.headquartersAddress,
		ISSUER_CITY: (isEnglish && company.companyDetails?.englishCity) ? company.companyDetails.englishCity : company.companyDetails?.city,
		ISSUER_TK: company.companyDetails?.postalCode,
		ISSUER_PHONE: (isEnglish && company.companyDetails?.englishPhone) ? company.companyDetails.englishPhone : company.companyDetails?.phone,
		ISSUER_DOY: company.companyDetails?.doy,
		ISSUER_VAT: isEnglish ? `EL${company.companyDetails?.vatNumber}` : company.companyDetails?.vatNumber,
		ISSUER_EMAIL: company.companyDetails?.email,
		ISSUER_GEMH: company.companyDetails?.gemhNo,
		ISSUER_WEBPAGE: company.companyDetails?.webpage,
		ISSUER_AMKA: company.companyDetails?.prescriptionDoctorDetails?.amka,
		BRANCH: branch,
		INVOICE_TYPE: quotationsData?.documentTypeName,
		SERIES: quotationsData?.preNumber !== "noprefix" ? quotationsData?.preNumber : "",
		NUMBER: String(quotationsData?.number).replace(quotationsData?.preNumber,''),
		INVOICE_DATE: templateDate,
		INVOICE_TIME: quotationsData?.time,
		CUSTOMER_CODE: quotationsData?.clientCode,
		CUSTOMER_NAME: quotationsData.myDataType === "11.1" || quotationsData.myDataType === "11.2" || quotationsData.myDataType === "11.4" ? quotationsData?.clientName : "",
		CUSTOMER_COMPANY: quotationsData.myDataType !== "11.1" && quotationsData.myDataType !== "11.2" && quotationsData.myDataType !== "11.4" ? quotationsData?.clientName : "",
		CUSTOMER_ACTIVITY: quotationsData?.activityName,
		CUSTOMER_EMAIL: quotationsData?.email,
		CUSTOMER_PHONE: quotationsData?.phone,
		CUSTOMER_VAT: quotationsData?.vat,
		CUSTOMER_AMKA: quotationsData?.amka,
		CUSTOMER_DOY: quotationsData?.doy,
		CUSTOMER_ADDRESS: quotationsData?.address,
		CUSTOMER_CITY: quotationsData?.city,
		CUSTOMER_ZIP: quotationsData?.pc,
		SALER_NAME: "",
		SALER_COMPANY_NAME: "",
		SALER_EMAIL: "",
		SALER_GEMH: "",
		SALER_VAT: "",
		TAX_REPRESENTATIVE: "",
		TAX_REPRESENTATIVE_VAT: "",
		LOCATION_NAME: "",
		HIGHLIGHT: "",
		IS_DELIVERY_NOTE: quotationsData?.isDeliveryNote,
		INVOICE_NOTES: quotationsData.notes,
		TOTAL_QTY: quotationsData.totalQuantity,
		TOTAL_WITHOUT_DISCOUNT: getGreekCurrencyFormat(quotationsData.totalBeforeDiscount),
		TOTAL_DISCOUNT: getGreekCurrencyFormat(quotationsData.totalDiscount),
		TOTAL_NOVAT: getGreekCurrencyFormat(quotationsData.totalNetValue),
		TOTAL_VAT: getGreekCurrencyFormat(quotationsData.totalVatValue),
		PRICE_WITHVAT: getGreekCurrencyFormat(quotationsData.totalAmount),
		TOTAL_PRICE: getGreekCurrencyFormat(quotationsData.paymentAmount),
		TOTAL_TAXES_AMOUNT: 0, // Other & Fees & Stamp
		MARK: quotationsData?.mark,
		UID: quotationsData?.uid,
		AUTHCODE: quotationsData?.authCode,
		TRANSMISSION_FAILURE: quotationsData?.transmissionFailure,
		PRODUCT_DETAILS: [],
		VAT_TABLE: [],
		TOTAL_PAGES: [],
		TOO_MANY_CUSTOMER_DETAILS: false,
	}
	if (!isEmpty(printTemplateData.CUSTOMER_DOY) && !isNaN(printTemplateData.CUSTOMER_DOY)) {
		const matchingDOY = getDOYOptions().find((el) => String(el.value) === String(printTemplateData.CUSTOMER_DOY));
		if (matchingDOY) printTemplateData.CUSTOMER_DOY = matchingDOY.label;
	}
	if (String(printTemplateData.CUSTOMER_NAME).length + String(printTemplateData.CUSTOMER_COMPANY).length
		+ String(printTemplateData.CUSTOMER_ACTIVITY).length + String(printTemplateData.CUSTOMER_ADDRESS).length > 60) {
		printTemplateData.TOO_MANY_CUSTOMER_DETAILS = true;
	}
	if (!isEmpty(quotationsData?.displayedBalance)) {
		printTemplateData.OLD_BALANCE = getGreekCurrencyFormat(String(quotationsData.displayedBalance).split(" ")[0]);
		printTemplateData.NEW_BALANCE = getGreekCurrencyFormat(String(quotationsData.displayedBalance).split(" ")[1]);
	}
	let totalWithhold = 0;
	let totalDeductions = 0;
	const invoiceLevelTax = quotationsData?.salesTaxes?.find((el) => el.vatPercentage === "Invoice Level Tax");
	if (invoiceLevelTax) {
		totalWithhold += parseFloat(invoiceLevelTax.withholdTaxes);
		if (invoiceLevelTax.deductions && !isNaN(invoiceLevelTax.deductions)) {
			totalDeductions += parseFloat(invoiceLevelTax.deductions);
		}
	}
	const ROW_HEIGHT = 30; // Set the height of each row in pixels
	let MAX_ROWS_PER_PAGE = 11; // Set the maximum number of rows per page
	printTemplateData.PRINT_SIZE = "A4"
	if (size === "A5") {
		MAX_ROWS_PER_PAGE = 6;
		printTemplateData.PRINT_SIZE = "A5"
	}
	let listProducts = [];
	let zeroVatReasons = [];

	if (quotationsData.products && quotationsData.products.length > 0) {
		listProducts = [];
		zeroVatReasons = [];
		let currentHeight = 0;
		let pageProducts = [];
		printTemplateData.TOTAL_PAGES.push(1);
		quotationsData.products.forEach((product) => {
			let cloneProduct = {...product};
			if (quotationsData?.discountAsLine === true) {
				cloneProduct.discount = 0;
				cloneProduct.netValue = cloneProduct.unitPrice * cloneProduct.quantity;
				cloneProduct.vat = (cloneProduct.unitPrice * cloneProduct.quantity) * (cloneProduct.vatPercentage / 100);
				cloneProduct.totalValue = cloneProduct.netValue + cloneProduct.vat;
			}
			let qtyLabel = measurementUnitsData.find((el) => String(product?.mu) === String(el.code));
			if (qtyLabel && String(product.mu) !== "4") {
				qtyLabel = qtyLabel.shortName;
				if (product.quantity === 1) {
					if (qtyLabel === "Κιλά") {
						qtyLabel = "Κιλό";
					} else if (qtyLabel === "Μέτρα") {
						qtyLabel = "Μέτρο";
					}
				}
			} else {
				qtyLabel = "";
			}
			let productData = {
				CPV_CODE: product?.cpvCode ? product.cpvCode : "",
				CODE: product.code,
				VAT_ID: product.vatId,
				TAXES_VALUE: parseFloat(
					parseFloat(product.otherTaxEuro) +
					parseFloat(product.feeEuro) +
					parseFloat(product.stampEuro)
				),
				PRODUCT_DESCRIPTION: product.name,
				QTY: String(product.quantity) + String(quotationsData?.enablePeppol === "active" ? "" : ` ${qtyLabel}`),
				PRICE_QTY: quotationsData?.enablePeppol === "active" ? Number(product.unitPrice).toFixed(3) : getGreekCurrencyFormat(product.unitPrice, 3),
				VAT: product.vatPercentage,
				DISCOUNT: quotationsData?.enablePeppol === "active" ? Number(cloneProduct.discount).toFixed(2) : String(cloneProduct?.isPerDiscount) !== "true" ? getGreekCurrencyFormat(cloneProduct.discount) : getGreekCurrencyFormat(cloneProduct.discount).replace("€", "%"),
				PRICE_NOVAT: quotationsData?.enablePeppol === "active" ? Number(cloneProduct.netValue).toFixed(2) : getGreekCurrencyFormat(cloneProduct.netValue),
				VAT_PRICE: product.taxes
					? getGreekCurrencyFormat(cloneProduct.vat)
					: getGreekCurrencyFormat(0),
				OTHER_TAXES: getGreekCurrencyFormat(
					parseFloat(
						parseFloat(product.otherTaxEuro) -
						parseFloat(product.witholdTaxEuro) +
						parseFloat(product.feeEuro) +
						parseFloat(product.stampEuro) -
						parseFloat(product?.deductionsEuro ? product?.deductionsEuro : 0)
					)
				),
				TOTAL: getGreekCurrencyFormat(cloneProduct.totalValue),
			}
			if (quotationsData?.enablePeppol === "active") productData.VAT_PRICE = parseFloat(product.vat).toFixed(2);
			printTemplateData.TOTAL_TAXES_AMOUNT += productData.TAXES_VALUE;
			if (product.vatId === 7) {
				zeroVatReasons.push(product.vatReason);
			}
			const productRowHeight = Math.ceil(
				product.name.length / 50 // Set the maximum number of characters per line
			) * ROW_HEIGHT;
			currentHeight += productRowHeight;
			if (currentHeight > MAX_ROWS_PER_PAGE * ROW_HEIGHT) {
				// Start a new page if the current page height exceeds the maximum
				printTemplateData.TOTAL_PAGES.push(1);
				listProducts.push(pageProducts);
				pageProducts = [];
				currentHeight = productRowHeight;
			}
			if (product?.showAlternativeCodeOnPrint === "true") productData.CODE = product.alternativeCode;
			if (product?.showAlternativeNameOnPrint === "true") productData.PRODUCT_DESCRIPTION = product.alternativeName;
			if (!isNaN(parseFloat(product.witholdTaxEuro))) {
				totalWithhold += parseFloat(product.witholdTaxEuro);
			}
			if (product?.deductionsEuro && !isEmpty(product?.deductionsEuro)) {
				totalDeductions += parseFloat(product.deductionsEuro);
			}
			pageProducts.push(productData);
		})
		listProducts.push(pageProducts);
	}
	// Fees, Other Taxes, Withhold Taxes, Stamps that are selected by user to be a line
	if (listProducts?.length > 0) {
		if (quotationsData.extraData[0]?.withHoldTaxAsLine === "true" && parseFloat(quotationsData.extraData[0]?.withHoldTaxEuro) > 0) {
			const pStr = "-" + parseFloat(quotationsData.extraData[0]?.withHoldTaxEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(quotationsData.extraData[0]?.withHoldTaxAsLineText) ? "Παρακράτηση Φόρου" : quotationsData.extraData[0]?.withHoldTaxAsLineText,
				QTY: "",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (quotationsData.extraData[0]?.deductionsAsLine === "true" && parseFloat(quotationsData.extraData[0]?.deductionsEuro) > 0) {
			const pStr = "-" + parseFloat(quotationsData.extraData[0]?.deductionsEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(quotationsData.extraData[0]?.deductionsAsLineText) ? "Γενικές κρατήσεις" : quotationsData.extraData[0]?.deductionsAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (quotationsData.extraData[0]?.feeAsLine === "true" && parseFloat(quotationsData.extraData[0]?.feeEuro) > 0) {
			const pStr = parseFloat(quotationsData.extraData[0]?.feeEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(quotationsData.extraData[0]?.feeAsLineText) ? "Τέλη" : quotationsData.extraData[0]?.feeAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (quotationsData.extraData[0]?.stampAsLine === "true" && parseFloat(quotationsData.extraData[0]?.stampEuro) > 0) {
			const pStr = parseFloat(quotationsData.extraData[0]?.stampEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(quotationsData.extraData[0]?.stampAsLineText) ? "Χαρτόσημο (Ψηφ. τέλος συν.) (Φόρος)" : quotationsData.extraData[0]?.stampAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (quotationsData.extraData[0]?.otherTaxAsLine === "true" && parseFloat(quotationsData.extraData[0]?.otherTaxEuro) > 0) {
			const pStr = parseFloat(quotationsData.extraData[0]?.otherTaxEuro).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: pStr,
				PRODUCT_DESCRIPTION: isEmpty(quotationsData.extraData[0]?.otherTaxAsLineText) ? "Λοιπός Φόρος" : quotationsData.extraData[0]?.otherTaxAsLineText,
				QTY: "1",
				PRICE_QTY: "0.00",
				DISCOUNT: "0.00",
				VAT: "0",
				PRICE_NOVAT: "0.00",
				VAT_PRICE: "0.00",
				OTHER_TAXES: pStr,
				TOTAL: getGreekCurrencyFormat(pStr),
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
		if (quotationsData?.discountAsLine === true) { // Need to edit previous lines, re-calculate totals
			let totalNetDisc = 0;
			let totalVatDisc = 0;
			for (let prod of quotationsData.products) {
				if (prod.isPerDiscount) {
					totalNetDisc += ((prod.unitPrice * prod.quantity)) * (prod.discount / 100);
					totalVatDisc += ((prod.unitPrice * prod.quantity) * (prod.vatPercentage / 100)) * (prod.discount / 100);
				} else {
					totalNetDisc += prod.discount;
					totalVatDisc += prod.discount * (prod.vatPercentage / 100);
				}
			}
			totalNetDisc = -totalNetDisc;
			totalVatDisc = -totalVatDisc;
			let displayNetDisc = getGreekCurrencyFormat(totalNetDisc);
			let displayVatDisc = getGreekCurrencyFormat(totalVatDisc);

			let discAm = +Number(totalNetDisc + totalVatDisc).toFixed(2);
			let prepFakeProduct = {
				CPV_CODE: "",
				CODE: "",
				VAT_ID: "8",
				TAXES_VALUE: "-",
				PRODUCT_DESCRIPTION: quotationsData.discountAsLineText,
				QTY: "",
				PRICE_QTY: displayNetDisc,
				DISCOUNT: "-",
				VAT: "-",
				PRICE_NOVAT: displayNetDisc,
				VAT_PRICE: displayVatDisc,
				OTHER_TAXES: "-",
				TOTAL: getGreekCurrencyFormat(discAm),
				DONT_SHOW_PERCENTAGE: true,
			}
			listProducts[listProducts.length - 1].push(prepFakeProduct);
		}
	}

	if (totalWithhold) {
		printTemplateData.TOTAL_WITHHOLD = getGreekCurrencyFormat(totalWithhold);
	}
	if (totalDeductions) {
		printTemplateData.TOTAL_DEDUCTIONS = getGreekCurrencyFormat(totalDeductions);
	}
	let taxesData = [];
	let vatDataList = vatCategoryData;
	let vatPerReasonList = vatZeroPerData; // Is used to get the reason in exceptional case
	// For PEPPOL BG-21
	if (quotationsData.extraData[0]) {
		if (quotationsData.extraData[0].otherTaxEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(quotationsData.extraData[0].otherTaxEuro);
		if (quotationsData.extraData[0].feeEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(quotationsData.extraData[0].feeEuro);
		if (quotationsData.extraData[0].stampEuro) printTemplateData.TOTAL_TAXES_AMOUNT += parseFloat(quotationsData.extraData[0].stampEuro);
	}
	if (printTemplateData.TOTAL_TAXES_AMOUNT > 0) printTemplateData.TOTAL_TAXES_AMOUNT = getGreekCurrencyFormat(printTemplateData.TOTAL_TAXES_AMOUNT);
	// Updated calculations for the sales taxes
	let newSalesTaxes = getSalesTaxesTemplateData(quotationsData.products, SETTINGS);
	if (newSalesTaxes && newSalesTaxes?.length > 0) {
		newSalesTaxes.forEach((tax) => {
			let taxVatPer = tax.vatPercentage;
			let taxVatPerWithoutSymbol = parseFloat(taxVatPer.replaceAll('%', ''));
			let vatObj = getObjectFromArrayOfObjects(vatDataList, taxVatPerWithoutSymbol, 'percentage');
			let taxCode = '';
			if (vatObj.length > 0) {
				taxCode = vatObj['0'].code;
			}
			let taxData = {
				TAX_PERCENT: taxVatPer,
				TAX_CODE: taxCode,
				NET_VALUE: getGreekCurrencyFormat(tax.netValue),
				TAX_VALUE: getGreekCurrencyFormat(tax.vatEuro),
				OTHER_TAXES: getGreekCurrencyFormat(tax.taxes),
				TOTAL_VALUE: getGreekCurrencyFormat(tax.totalValue),
			}
			for (let key of Object.keys(taxData)) {
				if (taxData[key] === "NaN") {
					taxData[key] = getGreekCurrencyFormat(0)
				}
			}
			taxesData.push(taxData);
		});
	}
	let zeroVatReasonDes = [];
	if (zeroVatReasons.length > 0) {
		zeroVatReasons.map(reason => {
			let vatReasonObj = getObjectFromArrayOfObjects(vatPerReasonList, reason, 'code');
			if(vatReasonObj['0'] !== undefined) {
				let zeroReason = {
					vat: "0%",
					description: (isEnglish ? vatReasonObj['0']?.english : vatReasonObj['0'].description) + ' (' + reason + ')',
					code: reason
				}
				zeroVatReasonDes.push(zeroReason);
			}
			return reason;
		})
	}
	zeroVatReasonDes = removeDuplicateObjects(zeroVatReasonDes, 'code');
	printTemplateData.VATEXPCAT = zeroVatReasonDes;
	printTemplateData.PRODUCT_DETAILS = listProducts;
	printTemplateData.VAT_TABLE = taxesData;

	printTemplateData.PAGE_TYPES = [];
	printTemplateData.dataType = type;

	return printTemplateData;
}

export const getClientPaymentPrintData = (COMPANY_DATA, cData) => {
	let branch = "";
	if(cData?.installation !== "0"){
		if(cData?.companyInstallations?.length > 0) {
			cData.companyInstallations.map(installation => {
				if (installation?.installationMasterId === cData?.installation) {
					branch = installation;
				}
				return installation;
			})
		}
	}
	let returnObj = {
		ISSUER_NAME: COMPANY_DATA.companyDetails?.name,
		ISSUER_LOGO: COMPANY_DATA.companyDetails?.useLogo === "active" ? COMPANY_DATA.companyDetails?.companyLogo : "",
		ISSUER_SMALL_NAME: COMPANY_DATA.companyDetails?.smallName,
		ISSUER_SUBJECTFIELD: COMPANY_DATA.companyDetails?.activity,
		ISSUER_ADDRESS: COMPANY_DATA.companyDetails?.headquartersAddress,
		ISSUER_CITY: COMPANY_DATA.companyDetails?.city,
		ISSUER_TK: COMPANY_DATA.companyDetails?.postalCode,
		ISSUER_PHONE: COMPANY_DATA.companyDetails?.phone,
		ISSUER_DOY: COMPANY_DATA.companyDetails?.doy,
		ISSUER_VAT: COMPANY_DATA.companyDetails?.vatNumber,
		ISSUER_EMAIL: COMPANY_DATA.companyDetails?.email,
		ISSUER_GEMH: COMPANY_DATA.companyDetails?.gemhNo,
		ISSUER_WEBPAGE: COMPANY_DATA.companyDetails?.webpage,
		ISSUER_AMKA: COMPANY_DATA.companyDetails?.prescriptionDoctorDetails?.amka,
		BRANCH: branch,
		CUSTOMER_CODE: cData?.clientCode,
		CUSTOMER_NAME: cData?.myDataType === "11.1" || cData?.myDataType === "11.2" || cData?.myDataType === "11.4" ? cData?.clientName : "",
		CUSTOMER_COMPANY: cData?.clientName,
		CUSTOMER_ACTIVITY: cData?.activity,
		CUSTOMER_EMAIL: cData?.email,
		CUSTOMER_PHONE: cData?.phone,
		CUSTOMER_VAT: cData?.vat,
		CUSTOMER_DOY: cData?.doy,
		CUSTOMER_ADDRESS: cData?.address,
		CUSTOMER_CITY: cData?.city,
		CUSTOMER_ZIP: cData?.pc,
		PAYMENT_DATE: moment(new Date(cData.date)).format("DD-MM-YYYY"),
		PAYMENT_TYPE: cData?.paymentTypeName,
		PAYMENT_AMOUNT: cData?.amount + " €",
		INVOICE_TYPE: cData?.documentTypeName,
		NUMBER: cData?.number,
		SERIES: cData?.preNumber,
		INVOICE_DATE: moment(new Date(cData.date)).format("DD-MM-YYYY"),
		INVOICE_TIME: moment(new Date(cData.date)).format("HH:mm"),
		INVOICE_NOTES: cData?.paymentNotes,
		PRINT_SIZE: "A4",
		UID: cData?.uid,
		MARK: cData?.mark,
		AUTHCODE: cData?.authCode,
		TRANSMISSION_FAILURE: cData?.transmissionFailure,
		MYDATA_DESTINATION: cData?.myDataDestination,
	}
	if (cData?.transactionDetails) {
		returnObj.TRANSACTION_DETAILS = cData.transactionDetails;
	}
	if (cData?.myDataDestination === "provider" && cData?.myDataStatus === "sent") {
		const qrCodeData = 'https://primer.gr/mydatasearch/' + cData?.uid;
		// Convert the canvas image to a base64 string
		returnObj.QR_CODE = QR.drawImg(qrCodeData, {
			typeNumber: 4,
			errorCorrectLevel: 'M',
			size: 190
		});
	}
	if (!isEmpty(cData?.displayedBalance)) {
		returnObj.OLD_BALANCE = getGreekCurrencyFormat(String(cData.displayedBalance).split(" ")[0]);
		returnObj.NEW_BALANCE = getGreekCurrencyFormat(String(cData.displayedBalance).split(" ")[1]);
	}
	return returnObj;
}


// Get Buys Print Data
export const getBuysPrintData = (type, buys, company, SETTINGS, printLayout)  => {
	let buysData = {};
	const isEnglish = String(printLayout).includes("english");
	const buysPurposeOptions = getMyData({type: 'buyPurpose', settings: SETTINGS});
	if (type === 'buys') {
		buysData = buys.newBuys;
	}
	if (type === 'editBuys') {
		buysData = buys.editBuys;
	}
	let branch = "";
	if(buysData?.installation !== "0"){
		if(company?.companyInstallations?.length > 0) {
			company.companyInstallations.map(installation => {
				if (installation?.installationMasterId === buysData?.installation) {
					branch = installation;
				}
				return installation;
			})
		}
	}

	let templateDate = new Date(buysData.date)
	templateDate = templateDate.getDate()+'/'+(templateDate.getMonth()+1)+'/'+templateDate.getFullYear();
	let printTemplateData = {
		ISSUER_NAME: company.companyDetails?.name,
		ISSUER_LOGO: company.companyDetails?.useLogo === "active" ? company.companyDetails?.companyLogo : "",
		ISSUER_SMALL_NAME: company.companyDetails?.smallName,
		ISSUER_SUBJECTFIELD: company.companyDetails?.activity,
		ISSUER_ADDRESS: company.companyDetails?.headquartersAddress,
		ISSUER_CITY: company.companyDetails?.city,
		ISSUER_TK: company.companyDetails?.postalCode,
		ISSUER_PHONE: company.companyDetails?.phoneNumber,
		ISSUER_DOY: company.companyDetails?.doy,
		ISSUER_VAT: company.companyDetails?.vatNumber,
		ISSUER_EMAIL: company.companyDetails?.email,
		ISSUER_GEMH: company.companyDetails?.gemhNo,
		ISSUER_AMKA: company.companyDetails?.prescriptionDoctorDetails?.amka,
		BRANCH: branch,
		INVOICE_TYPE: buysData?.documentTypeName,
		SERIES: buysData?.preNumber !== "noprefix" ? buysData?.preNumber : "",
		NUMBER: String(buysData?.number).replace(buysData?.preNumber,''),
		INVOICE_DATE: templateDate,
		INVOICE_TIME: buysData?.time,
		SUPPLIER_CODE: buysData?.supplierCode,
		SUPPLIER_NAME: buysData.myDataType === "11.1" || buysData.myDataType === "11.2" || buysData.myDataType === "11.4" ? buysData?.clientName : "",
		SUPPLIER_COMPANY: buysData?.supplierName,
		SUPPLIER_ACTIVITY: buysData?.supplierActivity,
		SUPPLIER_EMAIL: buysData?.email,
		SUPPLIER_VAT: buysData?.vat,
		SUPPLIER_ADDRESS: buysData?.address,
		SUPPLIER_CITY: buysData?.city,
		SUPPLIER_ZIP: buysData?.pc,
		SUPPLIER_PHONE: buysData?.phone,
		SUPPLIER_DOY: buysData?.doy,
		BUYER_NAME: "",
		BUYER_COMPANY_NAME: "",
		BUYER_EMAIL: "",
		BUYER_GEMH: "",
		BUYER_VAT: "",
		TAX_REPRESENTATIVE: "",
		TAX_REPRESENTATIVE_VAT: "",
		LOCATION_NAME: "",
		//LOCATION_ADDRESS: "",
		//LOCATION_COUNTRY: "",
		//LOCATION_CITY: "",
		//LOCATION_ZIP: "",
		PAYMENT_METHOD: buysData?.paymentTypeName,
		PURPOSE: getDefaultOptionByValue(buysPurposeOptions, buysData?.buyPurpose, 'value', 'label', 'value')?.label,
		HIGHLIGHT: "",
		CORRELATION: buysData?.correlationName,
		IS_DELIVERY_NOTE: buysData?.isDeliveryNote,
        VAT_PAYMENT_SUSPENSION: buysData?.vatPaymentSuspension === true,
		DISPATCH_TIME: buysData?.goodsSendDate ? getISOStringDateToDate(buysData?.goodsSendDate) : '',
		VEHICLE_NUMBER: buysData?.carNumberName,
		VATEXPCAT: "",
		VATEXPCATCODE: "",
		INVOICE_NOTES: buysData.notes,
		TOTAL_QTY: buysData.totalQuantity,
		TOTAL_WITHOUT_DISCOUNT: getGreekCurrencyFormat(buysData.totalBeforeDiscount),
		TOTAL_DISCOUNT: getGreekCurrencyFormat(buysData.totalDiscount),
		TOTAL_NOVAT: getGreekCurrencyFormat(buysData.totalNetValue),
		TOTAL_VAT: getGreekCurrencyFormat(buysData.totalVatValue),
		PRICE_WITHVAT: getGreekCurrencyFormat(buysData.totalAmount),
		TOTAL_PRICE: getGreekCurrencyFormat(buysData.paymentAmount),
		MARK: buysData?.mark,
		UID: buysData?.uid,
		AUTHCODE: buysData?.authCode,
		TRANSMISSION_FAILURE: buysData?.transmissionFailure,
		MYDATAENVIRONMENT: buysData?.myDataEnvironment,
		PRODUCT_DETAILS: [],
		VAT_TABLE: [],
		TOTAL_PAGES: [],
		PRINT_SIZE: "A4",
	}
	if (buysData?.receivingNotePurpose) {
		if (buysData.receivingNotePurpose === "7") {
			printTemplateData.RECEIVING_NOTE_PURPOSE = buysData?.otherReceivingNotePurposeTitle;
		} else {
			printTemplateData.RECEIVING_NOTE_PURPOSE = receivingNotePurposeOptions.find((el) => el.value === buysData.receivingNotePurpose)?.label || "-";
		}
	}
	let listProducts = [];
	let zeroVatReasons = [];
	if (buysData.products && buysData.products?.length > 0) {
		printTemplateData.TOTAL_PAGES.push(1);
		buysData.products.slice(0, 20).forEach((product, index) => {
			let productData = {
				CODE: product.showAlternativeCodeOnPrint === "true" ? product.alternativeCode : product.code,
				PRODUCT_DESCRIPTION: product.showAlternativeNameOnPrint === "true" ? product.alternativeName : product.name,
				QTY: product.quantity,
				PRICE_QTY: getGreekCurrencyFormat(product.unitPrice),
				VAT: product.vatPercentage,
				DISCOUNT: getGreekCurrencyFormat(product.discount),
				PRICE_NOVAT: getGreekCurrencyFormat(product.netValue),
				VAT_PRICE: product.taxes ? getGreekCurrencyFormat(product.vat) : getGreekCurrencyFormat(0),
				OTHER_TAXES: getGreekCurrencyFormat(parseFloat(parseFloat(product.otherTaxEuro) + parseFloat(product.witholdTaxEuro) + parseFloat(product.feeEuro) + parseFloat(product.stampEuro))),
				TOTAL: getGreekCurrencyFormat(product.totalValue),
			}
			if(product.vatId === 7){
				zeroVatReasons.push(product.vatReason)
			}
			listProducts.push(productData);
			if((index + 1) % 6 === 0){
				printTemplateData.TOTAL_PAGES.push(1);
			}
		});
	}
	let taxesData = [];
	let vatDataList = vatCategoryData;
	let vatPerReasonList = vatZeroPerData; // Is used to get the reason in exceptional case
	// Updated calculations for the buys taxes
	let newBuysTaxes = getBuysTaxesTemplateData(buysData.products, SETTINGS);
	if (newBuysTaxes && newBuysTaxes?.length > 0) {
		newBuysTaxes.forEach((tax) => {
			let taxVatPer = tax.vatPercentage;
			let taxVatPerWithoutSymbol = parseFloat(taxVatPer.replaceAll('%', ''));
			let vatObj = getObjectFromArrayOfObjects(vatDataList, taxVatPerWithoutSymbol, 'percentage');
			let taxCode = '';
			if (vatObj.length > 0) {
				taxCode = vatObj['0'].code;
			}
			let taxData = {
				TAX_PERCENT: taxVatPer,
				TAX_CODE: taxCode,
				NET_VALUE: getGreekCurrencyFormat(tax.netValue),
				TAX_VALUE: getGreekCurrencyFormat(tax.vatEuro),
				OTHER_TAXES: getGreekCurrencyFormat(tax.taxes),
				TOTAL_VALUE: getGreekCurrencyFormat(tax.totalValue),
			}
			taxesData.push(taxData);
		});
	}
	let zeroVatReasonDes = [];
	if (zeroVatReasons.length > 0) {
		zeroVatReasons.map(reason => {
			let vatReasonObj = getObjectFromArrayOfObjects(vatPerReasonList, reason, 'code');
			let zeroReason = {
				vat: "0%",
				description: (isEnglish ? vatReasonObj['0']?.english : vatReasonObj['0']?.description) + ' (' + reason + ')',
				code: reason
			}
			zeroVatReasonDes.push(zeroReason);
			return reason;
		})
	}
	zeroVatReasonDes = removeDuplicateObjects(zeroVatReasonDes, 'code');
	printTemplateData.VATEXPCAT = zeroVatReasonDes;
	printTemplateData.PRODUCT_DETAILS = listProducts;
	printTemplateData.VAT_TABLE = taxesData;
	if(buysData.myDataType && buysData?.extraData && buysData?.extraData.length > 0 && buysData?.myDataType !== "2.1" && buysData?.myDataType !== "2.2" && buysData?.myDataType !== "2.3" && buysData?.myDataType !== "2.4" && buysData?.myDataType !== "11.2" && buysData?.myDataType !== "7.1" && buysData?.myDataType !== "8.1" && buysData?.myDataType !== "8.2") {
		if (buysData?.extraData[0].deliveryLocation === "companyLocation") {
			printTemplateData.LOCATION_NAME = "ΕΔΡΑ ΜΑΣ";
		} else if (buysData?.extraData[0].deliveryLocation === "clientLocation") {
			printTemplateData.LOCATION_NAME = "ΕΔΡΑ ΠΕΛΑΤΗ";
			printTemplateData.LOCATION_ADDRESS = buysData?.address;
			printTemplateData.LOCATION_COUNTRY = buysData?.country;
			printTemplateData.LOCATION_CITY = buysData?.city;
			printTemplateData.LOCATION_ZIP = buysData?.pc;
		} else if (buysData?.extraData[0].deliveryLocation === "custom") {
			printTemplateData.LOCATION_NAME = "ΑΛΛΟ";
			printTemplateData.LOCATION_ADDRESS = buysData?.extraData[0].locationAddress;
			printTemplateData.LOCATION_COUNTRY = buysData?.extraData[0].locationCountry;
			printTemplateData.LOCATION_CITY = buysData?.extraData[0].locationCity;
			printTemplateData.LOCATION_ZIP = buysData?.extraData[0].locationZip;
		}
	}
	const qrCodeData = 'https://primer.gr/mydatasearch/' + buysData?.uid;
	// Convert the canvas image to a base64 string
	printTemplateData.QR_CODE = QR.drawImg(qrCodeData, {
		typeNumber: 4,
		errorCorrectLevel: 'M',
		size: 190
	});
	return printTemplateData;
}

// List of Wildcards Used on Email
export const salesEmailWildcardsList = () => {
	return [
		"{CompanyName}",
		"{CompanySmallName}",
		"{CompanyVAT}",
		"{CompanyDOY}",
		"{CompanyActivity}",
		"{CompanyAddress}",
		"{CompanyCity}",
		"{CompanyPostalCode}",
		"{CompanyPhone}",
		"{CompanyEmail}",
		"{ContactPointNameRow2}",
		"{ContactPointMobilePhoneRow2}",
		"{ContactPointLandlineRow2}",
		"{ContactPointOtherPhoneRow2}",
		"{ContactPointEmailRow2}"
	];
}

// List of Wildcards Used on Email
export const buysEmailWildcardsList = () => {
	return [
		"{CompanyName}",
		"{CompanySmallName}",
		"{CompanyVAT}",
		"{CompanyDOY}",
		"{CompanyActivity}",
		"{CompanyAddress}",
		"{CompanyCity}",
		"{CompanyPostalCode}",
		"{CompanyPhone}",
		"{CompanyEmail}",
		"{ContactPointNameRow2}",
		"{ContactPointMobilePhoneRow2}",
		"{ContactPointLandlineRow2}",
		"{ContactPointOtherPhoneRow2}",
		"{ContactPointEmailRow2}"
	];
}

// List of Wildcards Used on Sales Payment Reason
export const salesPaymentReasonWildcardsList = () => {
	return [
		"{ClientName}",
		"{DateOfReceipt}",
		"{ClientVAT}",
		"{PaymentType}",
	];
}

export const emailSettingsWildcardsList = () => {
	return [
		"{ClientName}",
		"{DateOfDocument}",
		"{ClientVAT}",
		"{PaymentAmount}",
		"{TotalAmount}",
		"{CompanyName}",
		"{CompanySmallName}",
	];
}
// List of Wildcards Used on Buys Payment Reason
export const buysPaymentReasonWildcardsList = () => {
	return [
		"{SupplierName}",
		"{DateOfReceipt}",
		"{SupplierVAT}",
		"{PaymentType}",
	]
}

// Sales Validation Check
export const isValidSalesData = (data) => {

	let validCheck = true;

	if (data.data === '') {
		validCheck = false
	}

	if (
		(data.clientType === 'Existing' && data.client === '') ||
		(data.clientType === 'New' && data.newClient === '')
		) {
		validCheck = false
	}

	if (data.clientType === 'New' && (data.email === '' || data.email === '')) {
		validCheck = false
	}

	if (data.products && data.products?.length === 0) {
		validCheck = false
	}

	return validCheck;
}

// Quotations Validation Check
export const isValidQuotationsData = (data) => {
	let validCheck = true;
	if (data.data === '') {
		validCheck = false
	}

	if (
		(data.clientType === 'Existing' && data.client === '') ||
		(data.clientType === 'New' && data.newClient === '')
	) {
		validCheck = false
	}

	if (data.clientType === 'New' && (data.email === '' || data.email === '')) {
		validCheck = false
	}

	if (data.products && data.products?.length === 0) {
		validCheck = false
	}
	return validCheck;
}


// Buys Validation Check
export const isValidBuysData = (data) => {

	let validCheck = true;

	if (data.data === '') {
		validCheck = false
	}

	if (
		(data.supplierType === 'Existing' && data.supplier === '') ||
		(data.supplierType === 'New' && data.newSupplier === '')
		) {
		validCheck = false
	}

	if (data.supplierType === 'New' && (data.email === '' || data.email === '')) {
		validCheck = false
	}

	if (data.products && data.products?.length === 0) {
		validCheck = false
	}

	return validCheck;
}

// Not a number filter
export const filterNaNValue = (value) => {
  if (isNaN(value)) return 0;
  return value;
}

export const checkPermissionMasterParentStartingTree = (perm, permissionsData) => {
	const user = JSON.parse(localStorage.getItem("user"));
	if (user.userType === "Admin") {
		return true;
	} else {
		if (permissionsData !== undefined && permissionsData !== null && permissionsData.length > 0) {
			return permissionsData.some((el) => String(el.permissionName).split("-")[0] === perm);
		} else {
			return false;
		}
	}
}
export const checkPermissionStartingTree = (perm, permissionsData) => {
	const user = JSON.parse(localStorage.getItem("user"));
	if (user.userType === "Admin") {
		return true;
	} else {
		if (permissionsData !== undefined && permissionsData !== null && permissionsData.length > 0) {
			return permissionsData.some((el) => String(el.permissionName).split("/")[0] === perm);
		} else {
			return false;
		}
	}
}
export const checkPermission = (perm, permissionsData) => {
	const user = JSON.parse(localStorage.getItem("user"));
	if (user.userType === "Admin") {
		return true;
	} else {
		if (permissionsData !== undefined && permissionsData !== null && permissionsData.length > 0) {
			return permissionsData.some((el) => String(el.permissionName) === perm);
		}
	}
}

export const isEmpty = (o) => {
	return o === undefined || o === null || String(o).trim() === "";
}

export const fixNetValueAndVat = (allAccounts) => {
	let accountsClone = [...allAccounts]
	if (accountsClone.length > 0) {
		accountsClone = accountsClone.map((a) => Object.assign({}, a));
		const matchingNetValues = ["24", "17", "13", "9", "6", "4", "3"];
		for (let vat of matchingNetValues) {
			let netValuesAccounts = accountsClone.filter((el) => el.isNetValue === vat);
			let vatValueAccount = accountsClone.find((el) => el.vat === vat);
			if (netValuesAccounts.length > 0 && vatValueAccount) {
				let netDebit = 0;
				let netCredit = 0;
				for (let netAcc of netValuesAccounts) {
					if(!isNaN(netAcc.debit)) netDebit += Number(netAcc.debit);
					if(!isNaN(netAcc.credit)) netCredit += Number(netAcc.credit);
				}
				netDebit = Number(Number(netDebit).toFixed(2));
				netCredit = Number(Number(netCredit).toFixed(2));

				let vatDebit = (Number(vat) / 100) * netDebit;
				let vatCredit = (Number(vat) / 100) * netCredit;
				vatDebit = Number(Number(vatDebit).toFixed(2));
				vatCredit = Number(Number(vatCredit).toFixed(2));
				vatValueAccount.debit = vatDebit;
				vatValueAccount.credit = vatCredit;
			}
		}
	}
	return accountsClone;
}

export const getCategoriesByInvoiceType = (invType, rowType) => {
	const findInvTypeObj = myDataCharOptions.find((el) => el.value === invType);
	if (findInvTypeObj) {
		if (rowType === "income") {
			return findInvTypeObj.category.filter((el) => String(el.value).startsWith("category1_") || String(el.value).startsWith("category3"));
		} else if (rowType === "expense") {
			return findInvTypeObj.category.filter((el) => String(el.value).startsWith("category2_"));
		}
	}
	return [];
}

export const getGreekMonthName = (monthNum) => {
	let num = Number(monthNum);
	const mapping = ["", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"];
	if (mapping[num]) return mapping[num];

	return "";
}

export const recalculateStockHolders = (arr = [], capital = 0) => {
	// Returns new stockholder array, based on new capital
	let cloneArr = structuredClone(arr);
	if (!isEmpty(capital)) {
		for (let holder of cloneArr) {
			if (!isNaN(holder.percentage) && holder.isActive === "true") {
				const percentage = parseFloat(holder.percentage);
				holder.stockValue = (percentage/100) * capital;
			}
		}
	}
	return cloneArr;
}
export const stockHolderPercentageDiff = (arr) => {
	let tp = 0;
	if (!Array.isArray(arr) || arr?.length === 0) return tp;
	for (let s of arr) {
		if (s.isActive === "true") tp += parseFloat(s.percentage);
	}
	tp = +Number(tp).toFixed(2);

	return tp - 100;
}

export const isValidNumber = (str) => {
	if (typeof str != "string") return false
	return !isNaN(str) && !isNaN(parseFloat(str))
}

export const removeEmptyValues = (obj) => {
	for (let key in obj) {
		if (obj[key] === null || obj[key] === undefined) {
			delete obj[key];
		}
	}
	return obj;
}

export const normalizeText = (text) => text.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[;΄¨]/g, '');

export const validateAFM = (afm) => {
	if (String(afm).length !== 9) return false; // "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί"
	if (!/^\d+$/.test(afm)) return false; // "Αυτό που εισάγετε δεν είναι αριθμός"

	const sum = afm.substring(0, 8).split('').reduce((s, v, i) => s + (parseInt(v) << 8 - i), 0);
	const calc = sum % 11;
	const d9 = parseInt(afm[8]);

	return calc % 10 === d9;
}

export const generateMyDataUID = (issuerVat, issueDate, issuerBranch, invoiceType, series, number) => {
	const toEncode = `${String(issuerVat)}-${String(issueDate)}-${String(issuerBranch)}-${String(invoiceType)}-${String(series)}-${String(number)}`;
	const encoded = encodeISO88597(toEncode);
	const sha1Encrypted = sha1(encoded);

	return String(sha1Encrypted).toUpperCase();
}

export const validateEmail = (email) => {
	if (!email || isEmpty(email)) return false;
	const tester = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

	const emailParts = email.split('@');
	if (emailParts.length !== 2) return false;

	const account = emailParts[0];
	const address = emailParts[1];
	if (account.length > 64 || address.length > 255) return false;

	const domainParts = address.split('.');
	if (domainParts.some((part) => part.length > 63)) return false;

	return tester.test(email);
}

export const getDocumentLabel = (data) => {
	let str = `${moment(data["date"]).format("DD/MM/YYYY")} ${data["documentTypeName"]} ${data["preNumber"] === "noprefix" ? data["number"] : data["preNumber"] + " " + data["number"]}`;
	if (data.reason) str += ` : ${data.reason}`;
	return str;
}

export const escapeRegex = (str) => {
	return String(str).replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
}

export const removeBoxesFromCanvas = (canvas) => {
	const context = canvas.getContext("2d");
	const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
	const data = imageData.data;
	const width = canvas.width;
	const height = canvas.height;
	let minHorizontalLength; // this depends on document DPI
	let minVerticalLength; // this depends on document DPI
	if (width <= 2481) {
		minHorizontalLength = 30;
	} else { // for more than 300 DPI
		minHorizontalLength = 60;
	}
	if (height <= 3508) {
		minVerticalLength = 30;
	} else { // for more than 300 DPI
		minVerticalLength = 60;
	}

	// Check if pixel is black
	function isBlack(x, y) {
		const index = (y * width + x) * 4;
		return data[index] === 0; // White = 255 / Black = 0
	}

	// Erase horizontal lines
	for (let y = 0; y < height; y++) {
		let startX = -1;
		for (let x = 0; x < width; x++) {
			if (isBlack(x, y)) {
				if (startX === -1) startX = x;
			} else {
				if (startX !== -1 && x - startX >= minHorizontalLength) {
					for (let i = startX; i < x; i++) {
						const index = (y * width + i) * 4;
						data[index] = data[index + 1] = data[index + 2] = 255;
					}
				}
				startX = -1;
			}
		}
	}
	// Erase vertical lines
	for (let x = 0; x < width; x++) {
		let startY = -1;
		for (let y = 0; y < height; y++) {
			if (isBlack(x, y)) {
				if (startY === -1) startY = y;
			} else {
				if (startY !== -1 && y - startY >= minVerticalLength) {
					for (let i = startY; i < y; i++) {
						const index = (i * width + x) * 4;
						data[index] = data[index + 1] = data[index + 2] = 255;
					}
				}
				startY = -1;
			}
		}
	}
	context.putImageData(imageData, 0, 0);
}

export const expandSearch = (term) => {
	if (!term || typeof term !== 'string') return new RegExp(`.`);

	let cleanTerm = term.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
	cleanTerm = cleanTerm.replace(/[^a-z0-9\u0370-\u03ff\s]/g, '');
	if (!cleanTerm.trim()) return new RegExp(`.`);

	const greekLatinMap = {
		'ντ': '(d|nt|ντ)', 'μπ': '(b|mp|μπ)', 'γκ': '(g|gk|γκ)', 'τζ': '(g|tz|τζ)', 'τσ': '(ts|ch|c|tc|τσ)',
		'ου': '(ou|u|ου)', 'αι': '(ai|e|αι)', 'ει': '(ei|i|ει)', 'οι': '(oi|i|οι)',
		'αυ': '(au|av|af|αυ)', 'ευ': '(eu|ev|ef|ευ)',
		'α': '(α|a)', 'β': '(β|b|v)', 'γ': '(γ|g|y)',
		'δ': '(δ|d)', 'ε': '(ε|e)', 'ζ': '(ζ|z)',
		'η': '(η|h|i|e)',
		'θ': '(θ|th)', 'ι': '(ι|i)', 'κ': '(κ|k|c)', 'λ': '(λ|l)', 'μ': '(μ|m)',
		'ν': '(ν|n)', 'ξ': '(ξ|x|ks)', 'ο': '(ο|o)', 'π': '(π|p)', 'ρ': '(ρ|r)',
		'σ': '(σ|s|c)', 'ς': '(σ|s|c)', 'τ': '(τ|t)', 'υ': '(υ|y|u|v)',
		'φ': '(φ|f|ph)', 'χ': '(χ|ch|x|h)', 'ψ': '(ψ|ps)', 'ω': '(ω|o|w)'
	};

	const latinGreekMap = {
		'th': '(θ|th)', 'ps': '(ψ|ps)', 'ks': '(ξ|ks|x)', 'ch': '(χ|τσ|ch)', 'ph': '(φ|f|ph)',
		'ts': '(τσ|ts)', 'tz': '(τζ|tz)', 'nt': '(ντ|nt)', 'mp': '(μπ|mp)', 'ou': '(ου|ou)',
		'sh': '(σ|sh)',
		'a': '(α|a)', 'b': '(β|μπ|b)', 'c': '(κ|σ|τσ|c)',
		'd': '(δ|ντ|d)', 'e': '(ε|αι|e)',
		'f': '(φ|f)', 'g': '(γ|γκ|τζ|g)', 'h': '(η|χ|h)',
		'i': '(ι|η|υ|ει|οι|i)',
		'j': '(τζ|γι|j)', 'k': '(κ|k)', 'l': '(λ|l)',
		'm': '(μ|m)', 'n': '(ν|n)', 'o': '(ο|ω|o)', 'p': '(π|p)', 'q': '(κ|q)',
		'r': '(ρ|r)', 's': '(σ|ς|s)', 't': '(τ|t)', 'u': '(υ|ου|u)',
		'v': '(β|v)', 'w': '(ω|w)', 'x': '(ξ|χ|x)',
		'y': '(υ|γ|y)',
		'z': '(ζ|z)'
	};

	const optionalGap = '[^a-z0-9\\u0370-\\u03ff]*';

	const buildRegexForWord = (word, map) => {
		let parts = [];
		let i = 0;

		while (i < word.length) {
			const twoChars = word.substring(i, i + 2);
			if (map[twoChars]) {
				parts.push(map[twoChars]);
				i += 2;
				continue;
			}
			const char = word[i];
			parts.push(map[char] ? map[char] : char);
			i++;
		}

		return parts.join(optionalGap);
	};

	const words = cleanTerm.trim().split(/\s+/);
	const regexWords = words.map(word => {
		const isGreek = /^[\u0370-\u03FF]/.test(word);
		return buildRegexForWord(word, isGreek ? greekLatinMap : latinGreekMap);
	});

	const finalRegexString = regexWords.join(optionalGap);

	return new RegExp(finalRegexString, 'i');
}

export const getAvailableClientServiceTypes = (permissionsData) => {
	let options = [];
	for(const option of clientServiceTypes) {
		if(checkPermission(option.permission, permissionsData)) {
			options.push({label: option.label, value: option.value});
		}
	}
	return options;
}

export const getAvailableServiceTypes = (clientServiceType) => {
	let options = [];
	if(clientServiceType === "2" || clientServiceType === "3" || !clientServiceType) {
		options = [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής/Λήψη Δικαιώματος"}];
	} else if(clientServiceType === "1") {
		options = [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής/Λήψη Δικαιώματος"}, {value: "continuousLease", label: "Διαρκής Μίσθωση/Υπηρεσία"}];
	}
	return options;
}

export const getAvailableDclServices = (clientServiceType) => {
	let options = [];
	if(clientServiceType === "2") {
		options = [
			{value: "", label: "Κενό"},
			{value: "7", label: "Υπηρεσία Βάσει Τιμοκαταλόγου"},
			{value: "8", label: "Υπηρεσία Βάση Συμφωνίας"},
			{value: "5", label: "Λοιπά"},
		];
	} else if(clientServiceType === "3") {
		options = [
			{value: "", label: "Κενό"},
			{value: "1", label: "Εργασία με χρήση ανταλλακτικών"},
			{value: "2", label: "Εργασία με χρήση ανταλλακτικών πελάτη"},
			{value: "3", label: "Εργασία χωρίς χρήση ανταλλακτικών"},
		];
	}
	return options;
}

export const getAvailableDclNoIssueTypes = (clientServiceType) => {
	let options = [];
	if(clientServiceType === "1" || clientServiceType === "2") {
		options = [{label: "Δωρεάν Υπηρεσία", value: "1"}, {label: "Ιδιόχρηση", value: "2"}];
	} else if(clientServiceType === "3") {
		options = [{label: "Δωρεάν Υπηρεσία", value: "1"}, {label: "Ιδιόχρηση", value: "2"}, {label: "Αποζημίωση Παροχής Εγγύησης", value: "3"}];
	}
	return options;
}

export const createAllCombinations = (n) => {
	const result = [];
	const backtrack = (start, combo) => {
		if (combo.length > 0) result.push([...combo]);

		for (let i = start; i <= n; i++) {
			combo.push(i);
			backtrack(i + 1, combo);
			combo.pop();
		}
	}
	backtrack(0, []);
	return result;
}

export const handleSaveMyDataClassifications = async (classificationsRowData, companyId, reportType) => {
	const newClassifications = structuredClone(classificationsRowData.classifications);
	const perRowClass = [...classificationsRowData.myDataClassifications];
	if (perRowClass.length > 0) {
		const rowsMatched = [];
		for (let row of perRowClass) {
			const includeVAT = row.classificationCategory === "category2_5";
			const combinations = createAllCombinations(classificationsRowData.classifications.length - 1);
			let foundCombo = null;
			for (let comb of combinations) {
				if (rowsMatched.some((el) => comb.includes(el))) continue;
				let total = 0;
				for (let i of comb) {
					const net = +classificationsRowData.classifications[i].netPrice;
					const vat = +classificationsRowData.classifications[i].vatAmount;
					total += includeVAT ? net + vat : net;
					total = +Number(total).toFixed(2);
				}
				if (total === row.classificationValue) { // Found matching sum
					foundCombo = comb;
					for (let i of foundCombo) rowsMatched.push(i);
					break;
				}
			}
			if (foundCombo) {
				for (let i of foundCombo) {
					newClassifications[i].classificationCategory = row.classificationCategory;
					newClassifications[i].classificationType = row.classificationType;
					if (reportType === "buys" && includeVAT) newClassifications[i].vatExpenseType = "";
				}
			} else {
				return toast.error("Δεν ήταν δυνατή η αντιστοιχία συνόλων Ε3 - γραμμών MyData.");
			}
		}
	}
	try {
		const response = await axios.post(`${process.env.REACT_APP_API_URL2}/report/save-mydata-classifications`, {
			company: companyId,
			mark: classificationsRowData.mark,
			newClassifications: newClassifications,
			reportType: reportType,
		})
		if (response.data.status === "200") {
			return { status: "200", message: "OK" }
		} else {
			return { status: "400", message: response.data.message }
		}
	} catch (axioError) {
		console.log(axioError);
		return { status: "400", message: "Σφάλμα κατά την αποστολή αιτήματος."}
	}
}

export const truncateHTML = (html, maxLength) => {
	const div = document.createElement("div");
	div.innerHTML = html;
	let totalLength = 0;
	let reachedLimit = false;
	const processNode = (node) => {
		if (reachedLimit) return null;
		if (node.nodeType === Node.TEXT_NODE) {
			const text = node.textContent || '';
			if (totalLength + text.length <= maxLength) {
				totalLength += text.length;
				return document.createTextNode(text);
			} else {
				const remaining = maxLength - totalLength;
				totalLength = maxLength;
				reachedLimit = true;
				return document.createTextNode(text.slice(0, remaining) + '...');
			}
		}
        if (node.nodeType === Node.ELEMENT_NODE) {
            if (["img", "video", "svg", "iframe"].includes(String(node.tagName).toLowerCase())) return null;

            // Adjust header to one level smaller
            let cloneTag = node.tagName.toLowerCase();
            if (/^h[1-6]$/.test(cloneTag)) {
                const level = Math.min(parseInt(cloneTag[1]) + 1, 6);
                cloneTag = `h${level}`;
            }

            const clone = document.createElement(cloneTag);

            // Copy attributes if needed:
            for (const attr of node.attributes) clone.setAttribute(attr.name, attr.value);

            for (const child of node.childNodes) {
                const newChild = processNode(child);
                if (newChild) clone.appendChild(newChild);
                if (reachedLimit) break;
            }
            return clone;
        }
		return null;
	}
	const resultDiv = document.createElement("div");
	for (const child of div.childNodes) {
		const processed = processNode(child);
		if (processed) resultDiv.appendChild(processed);
		if (reachedLimit) break;
	}
	const output = resultDiv.innerHTML;
	div.innerHTML = "";
	resultDiv.innerHTML = "";
	return output;
}

export const truncateString = (str, maxLength = 200, cuttingStr = "...") => {
	if (typeof str !== 'string') return '';
	if (str.length <= maxLength) return str;
	return String(str).slice(0, maxLength - cuttingStr.length) + cuttingStr;
}

export const quickClone = (value) => {
    if (value === null || typeof value !== "object") return value; // Primitives
    if (typeof value === "function") return undefined; // Skip functions
    if (Array.isArray(value)) return value.map((item) => quickClone(item)).filter((item) => item !== undefined); // Clone arrays

    // Clone plain objects
    const cloned = {};
    for (const key in value) {
        const val = value[key];
        if (typeof val !== "function") {
            const clonedVal = quickClone(val);
            if (clonedVal !== undefined) cloned[key] = clonedVal;
        }
    }
    return cloned;
}

export const DISABLED_PRODUCT_CATEGORIES = [
    "ΥΠΗΡΕΣΙΕΣ",
    "ΕΜΠΟΡΕΥΜΑΤΑ",
    "Α' - Β' ΥΛΕΣ",
    "ΠΡΟΙΟΝΤΑ",
	"ΔΑΠΑΝΕΣ",
	"ΛΟΙΠΑ ΕΙΔΗ",
]

export const BANKING_INSERTION_DISABLED_CATEGORIES = [
	"Πελάτες / Προμηθευτές",
	"Πληρωμές Δημοσίου",
	"Μισθοδοσία",
	"Ενδοεταιρικές διακινήσεις",
	"Δάνεια",
	"Τράπεζες",
	"Επιταγές",
]

export const DISABLED_BANKING_CATEGORIES = [
	"Πελάτες / Προμηθευτές",
	"Πληρωμή σε προμηθευτή",
	"Επιστροφή από προμηθευτή",
	"Είσπραξη απο πελάτη",
	"Επιστροφή σε πελάτη",

	"Πληρωμές Δημοσίου",
	"Πληρωμή Φ.Π.Α.",
	"Επιστροφή Φ.Π.Α.",
	"Πληρωμή ασφαλιστικών ταμείων",
	"Επιστροφή πληρωμής ασφαλιστικών ταμείων",
	"Πληρωμή Φόρων προς Δημόσιο",
	"Επιστροφή Φόρων απο Δημόσιο",
	"Πληρωμή ασφαλιστικού ταμείου ΤΕΚΑ",
	"Πληρωμή εργοδοτικών εισφορών",

	"Μισθοδοσία",
	"Πληρωμή Μισθοδοσίας",
	"Επιστροφή χρημάτων Μισθοδοσίας",
	"Αμοιβές Διοικητικού Συμβουλίου",
	"Επιστροφή αμοιβών Διοικητικού Συμβουλίου",

	"Ενδοεταιρικές διακινήσεις",
	"Ενδοεταιρική μεταφορά απο λογαριασμό σε λογαριασμό εταιρίας",
	"Ανάληψη μετρητών σε ταμείο",
	"Κατάθεση μετρητών από ταμείο",

	"Δάνεια",
	"Πληρωμή Δανείου",
	"Εκταμίευση Δανείου",

	"Τράπεζες",
	"Έξοδα τραπέζης (Commissions, Έξοδα διατήρησης λογαριασμού, Έξοδα αντιγράφων λογαριασμού)",
	"Έσοδα απο τόκους",
	"Είσπραξη πακέτου καρτών από POS - vouchers",
	"Πληρωμή Πιστωτικής Κάρτας",
	"Φόρτιση Prepaid card",

	"Επιταγές",
	"Πληρωμή Επιταγής",
	"Είσπραξη Επιταγής",

	"Λοιπά",
]

export const arraysOfObjectsChanged = (arr1, arr2) => {
	if (arr1 === arr2) return false;
	if (!Array.isArray(arr1) || !Array.isArray(arr2)) return true;
	if (arr1.length !== arr2.length) return true;

	const normalize = (arr) =>
		arr
			.map(obj => JSON.stringify(
				Object.keys(obj).sort().reduce((acc, key) => {
					acc[key] = obj[key];
					return acc;
				}, {})
			))
			.sort();

	const a = normalize(arr1);
	const b = normalize(arr2);

	return a.some((val, i) => val !== b[i]);
}

export const hookCompanyLogo = (doc, companyDetails) => {
	if (!companyDetails || !companyDetails.companyLogo || isEmpty(companyDetails.companyLogo) || companyDetails.useLogo !== "active") return;

	const logoImage = companyDetails.companyLogo;
	const imgWidth = 42;
	const imgHeight = 12;
	const imgX = doc.internal.pageSize.getWidth() - 50;
	const imgY = 4;

	try {
		doc.addImage(logoImage, 'PNG', imgX, imgY, imgWidth, imgHeight);
	} catch (e) {
		console.error("Error rendering optional company logo:", e);
	}
}

export const isBrowserSafari = () => {
	try {
		const ua = window.navigator.userAgent.toLowerCase();
		return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('chromium');
	} catch {
		return false;
	}
}

export const delay = async (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export const fastTable = (tableName, columns, data) => {
	return (
		<table className={"transfers-table"} style={{width: "100%"}}>
			<thead>
			<tr>
				{columns.map((col, idx) => (
					<th key={`${tableName}-thead-${idx}`}>{col}</th>
				))}
			</tr>
			</thead>
			<tbody>
			{data.map((row, idx) => (
				<tr key={`${tableName}-row-${idx}`}>
					{Array.isArray(row) ? (
						<React.Fragment>
							{row.map((cell, idx2) => (
								<td key={`${tableName}-cell-${idx}-${idx2}`}>
									{cell}
								</td>
							))}
						</React.Fragment>
					) : (
						<td key={`${tableName}-cell-${idx}-ucell`}>
							{row}
						</td>
					)}
				</tr>
			))}
			</tbody>
		</table>
	)
}

export const jwtDecode = (token) => {
	if (!token || typeof token !== 'string') throw new Error('Invalid token specified');

	const parts = token.split('.');

	if (parts.length !== 3) throw new Error('Invalid token specified: JWT must contain 3 parts');

	try {
		// Replace URL-safe base64 characters
		const base64Url = parts[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

		// Decode base64 and handle UTF-8 character encoding correctly
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		)
		return JSON.parse(jsonPayload);
	} catch (error) {
		throw new Error('Invalid token specified: failed to decode');
	}
}
